export const i18n_en_us = {
  brazil_elections: {
    hero: {
      title: 'Brazil Election Predictions on Futuur',
      title_line_1: 'Odds for the 2026 elections in Brazil',
      first_round_in: 'First round in',
      scroll: 'Scroll',
      share: 'Share',
      share_title: 'Brazil Election 2026 — live predictions on Futuur',
    },
    countdown: {
      aria: 'Time left until the first round of voting',
      days: 'Days',
      hours: 'Hours',
      minutes: 'Mins',
      seconds: 'Seconds',
    },
    duel: {
      eyebrow: 'Presidential race',
      title: "Brazil's Next President Elect prediction",
      chance: "${this.name}'s chance",
      cta: 'View all candidates',
    },
    trade: {
      label: 'Trade',
      payout: '${this.stake} → ${this.payout}',
    },
    first_round: {
      yes: 'YES',
      no: 'NO',
    },
    result: {
      title: 'Result',
      awaiting: 'Awaiting result',
      elected: 'Elected',
      not_elected: 'Not elected',
    },
    trending: {
      title: 'Trending races',
      view_all: 'View all election markets →',
    },
    races: {
      governor: 'Governor',
      senate: 'Senate',
    },
    table: {
      title: 'All races',
      count: '${this.count} markets',
    },
    ledger: {
      state: 'State',
      market: 'Market',
      leader: 'Leading outcome',
    },
    faq: {
      title: 'Frequently asked questions',
      what_is: {
        q: 'What is a prediction market?',
        a: 'A prediction market is an exchange where people trade shares in the outcome of a future event. Share prices move between 0 and 100 and reflect the probability the crowd assigns to that outcome. On Futuur you can trade with free play money or with real money where allowed.',
      },
      how_odds: {
        q: 'How are the percentages on this page calculated?',
        a: 'Each percentage is the latest trade price of that outcome on Futuur. When many forecasters buy an outcome its price rises, and when they sell it falls, so the number is a live, crowd-sourced probability rather than an editorial opinion.',
      },
      dates: {
        q: 'When is the 2026 Brazilian election?',
        a: 'The first round is on Sunday, 4 October 2026. A presidential run-off, if needed, takes place on Sunday, 25 October 2026. Governors in states where no candidate wins a majority also go to a second round on the same day.',
      },
      second_round: {
        q: 'What does "decided in the first round" mean?',
        a: 'A presidential candidate wins outright in the first round by taking more than 50% of valid votes. The market on this page prices the chance that happens, so a NO price of 65% means the crowd expects a run-off.',
      },
      free: {
        q: 'Can I forecast for free?',
        a: 'Yes. Every Futuur account starts with play money (ø), so you can back your predictions on any race without depositing. Real-money markets are available separately where local rules allow.',
      },
    },
    jsonld: {
      politics: 'Politics',
      event_name: 'Brazil general election 2026',
    },
    empty: {
      title: 'Election markets are not available here yet',
      description: 'This environment has no Brazil 2026 markets configured. Browse the politics category instead.',
    },
  },
  campaigns: {
    br_bonus: {
      title: 'You are in!',
      body: 'Make a deposit within 30 days and you get a 100% bonus, up to $10 USD.',
    },
  },

  api_errors: {
    generic: {
      title: 'Something went wrong',
      body: 'We could not complete this action. Please try again in a moment.',
    },
    network: {
      title: 'Connection lost',
      body: 'Check your internet connection and try again.',
    },
    order_book_unavailable: 'We could not load the order book. Prices may be out of date — please refresh.',
    order_book_incomplete: 'Some orders could not be displayed. Refresh to see the full book.',
    codes: {
      not_authenticated: 'Your session has expired. Please log in again.',
      authentication_failed: 'We could not verify your login. Please sign in again.',
      permission_denied: "You don't have permission to do this.",
      not_found: 'We could not find what you were looking for.',
      throttled: 'Too many attempts. Please wait a moment and try again.',
      parse_error: 'We received an unexpected response. Please try again.',
      method_not_allowed: 'This action is not available right now.',
      validation_error: 'Please review the highlighted fields and try again.',
      required: 'This field is required.',
      invalid: 'The value you entered is not valid.',
      blank: 'This field cannot be empty.',
      unique: 'This value is already in use.',
      invalid_choice: 'Please pick one of the available options.',
      max_length: 'The value you entered is too long.',
      min_length: 'The value you entered is too short.',
      balance_not_enough: 'Your balance is not enough for this transaction. Add funds or lower the amount.',
      balance_not_enough_with_opened_withdrawals:
        'Your balance is tied up in a pending withdrawal. Cancel or finish that withdrawal, then try again.',
      amount_invalid: 'That amount is not valid. Please enter a different amount.',
      question_closed: 'This market is closed and no longer accepts bets.',
      max_shares_per_wager: 'You have reached the maximum number of shares allowed for a single bet.',
      wager_action_duplicated: 'Your last bet is still being processed. Please wait a few seconds and try again.',
      user_email_not_confirmed: 'Confirm your email address before continuing. Check your inbox for our message.',
      bets_blocked: 'Betting is paused on your account. Finish identity verification in Account Settings to continue.',
      real_money_bet_not_allowed: 'Real money bets are not available on your account. Contact support for help.',
      invalid_hmac_key: 'That security key is not valid. Please check it and try again.',
      OrderBookInvalidAmount: 'That amount is not valid for this order. Please try a different amount.',
      OrderBookConflictingOrders: 'You already have an order on the other side of this market. Cancel it to continue.',
      wrong_password: 'That password is incorrect. Please try again.',
      email_not_found: 'We could not find an account with that email address.',
      email_already_exists: 'An account already uses this email address.',
      username_already_exists: 'That username is taken. Please pick another one.',
      invalid_token: 'This link has expired or was already used. Please request a new one.',
      invalid_2fa_token: 'That verification code is not correct. Please try again.',
    },
    titles: {
      save_settings: 'Settings not saved',
      update_profile: 'Profile not updated',
      update_password: 'Password not changed',
      login: 'Could not sign you in',
      api_keys: 'API keys unavailable',
      deposit: 'Deposit failed',
      withdraw: 'Withdrawal failed',
      promo_code: 'Code not redeemed',
      campaign: 'Could not join the campaign',
      two_factor: 'Two-factor authentication failed',
      account_info: 'Could not load your account',
      load_comments: 'Comments unavailable',
      post_comment: 'Comment not posted',
      reply_comment: 'Reply not posted',
      like_comment: 'Could not like the comment',
      unlike_comment: 'Could not remove your like',
      hide_comment: 'Could not update the comment',
      report_comment: 'Report not sent',
      delete_comment: 'Comment not deleted',
      search: 'Search unavailable',
      load_profile: 'Profile unavailable',
      order_book: 'Order book unavailable',
      order_book_incomplete: 'Order book incomplete',
      place_bet: 'Bet not placed',
      sell_bet: 'Sale not completed',
      cancel_order: 'Order not cancelled',
    },
  },
  bridge: {
    quote_failed: {
      title: 'Could not get a quote',
      body: 'We could not price this bridge transfer right now. Please try again in a moment.',
    },
    no_route: {
      title: 'No transfer route available',
      body: 'There is no route for this pair and amount right now. Try a different amount or token.',
    },
    routes_failed: {
      title: 'Could not load transfer routes',
      body: 'We could not reach the bridge provider. Please try again in a moment.',
    },
    executing: {
      title: 'Confirm in your wallet',
      body: 'Approve the transaction in your wallet to start the transfer.',
    },
    executed: {
      title: 'Transfer submitted',
      body: 'Your bridge transfer is on its way. It may take a few minutes to arrive.',
    },
    execution_failed: {
      title: 'Transfer failed',
      body: 'The bridge transaction did not go through. No funds were moved — please try again.',
    },
  },
  orders: {
    limit_order_placed: {
      title: 'Limit order placed',
      body: 'We will fill it as soon as the market reaches your price.',
    },
    order_filled: {
      title: 'Order filled',
      body: 'Your limit order was executed in full.',
      body_detail: 'Your ${this.side} order for ${this.shares} shares at $${this.price} was filled in full.',
    },
    partial_fill: {
      title: 'Order partially filled',
      body: 'Part of your limit order was executed. The rest stays open.',
      body_detail: '${this.filled} of ${this.total} shares filled at $${this.price}. ${this.remaining} still open.',
    },
    order_cancelled: {
      title: 'Order cancelled',
      body: 'Your open order was cancelled and any reserved funds were released.',
    },
  },
  chatbot: {
    voice_error: {
      title: 'Microphone unavailable',
      body: 'We could not access your microphone. Check your browser permissions and try again.',
    },
    voice_session_error: {
      title: 'Voice chat unavailable',
      body: 'We could not start the voice session. Please try again.',
    },
    voice_started: {
      title: 'Voice chat on',
      body: 'You can speak to the assistant now.',
    },
    voice_ended: {
      title: 'Voice chat off',
      body: 'The voice session has ended.',
    },
    navigation_failed: {
      title: 'Could not open that page',
      body: 'We could not take you there. Please use the menu to navigate.',
    },
  },
  Real_money: 'Real money',
  Play_money: 'Play money',
  in_Real_Money: 'in Real Money',
  in_Play_Money: 'in Play Money',
  yes: 'Yes',
  no: 'No',
  Login_to_your_account: 'Login to your account',

  Proceed: 'Proceed',

  global: {
    locale: 'en_US',
    content_language: 'en',
    general_description:
      'Find the most accurate and up-to-date forecasts on Futuur.  Better predictions, driven by the wisdom of the crowd.',
  },

  error_messages: {
    feed_page_crash: 'This wasn&apos;t predicted <br /> We we&apos;re unable to load the markets, please try again',
    wager_balance_not_enough: 'Not enough funds in your wallet.',
    wager_question_closed: 'Question not available for betting.',
    wager_outcome_conflict: 'You already have a wager on another outcome of this question. Sell it and try again.',
    wager_amount_invalid: 'The amount defined is not valid. Please select a valid amount or contact us for support.',
    wager_max_shares_per_wager: 'Sorry, you have reached the max shares per wager ',
  },
  cancel_withdraw: {
    exit: 'TAKE ME BACK',
    title: 'Are you sure you want to cancel this request?',
    action: 'I WANT TO CANCEL REQUEST',
    description:
      'Your transaction will remain in your account, and will not be transferred. You can make another request at any time',
  },
  snackbar: {
    copylink: 'Copied to the Clipboard',
  },

  footer: {
    title: 'Bet on the future',
    logo_home_link: 'Futuur home',
    navigation_label: 'Footer',
    social_twitter: 'Futuur on X (Twitter)',
    social_discord: 'Futuur on Discord',
    social_substack: 'Futuur on Substack',
    social_instagram: 'Futuur on Instagram',
    social_facebook: 'Futuur on Facebook',
    social_youtube: 'Futuur on YouTube',
    social_linkedin: 'Futuur on LinkedIn',
    about: 'About Us',
    signup: 'Sign up now',
    how_works: 'About Futuur',
    terms: 'Terms and Conditions',
    privacy: 'Privacy Policy',
    contest_rules: 'Competition Rules',
    explore: 'Explore',
    leaderboard: 'Top Forecasters',
    questions: 'Top Markets',
    politics: 'Politics',
    sports: 'Sports',
    finance: 'Finance',
    entertainment: 'Entertainment',
    science: 'Science',
    engage: 'Engage',
    suggest: 'Suggest a Market',
    contact: 'Contact Us',
    community: 'Community',
    language_title: 'Language',
    language: 'Português Brasileiro',
    copyright: 'Futuur© all rights reserved',
    report: 'Report a bug',
    hiring: "We're hiring",
    career: 'Career',
    api_docs: 'Public API',
    help_center: 'Help Center',
    disclaimer:
      'Futuur is a prediction market providing more accurate forecasts across a range of topics, powered by the wisdom of the crowd.',
    psp_disclamer:
      'Futuur is owned and operated by Futuur Anjouan Ltd., an Anjouan company with registered address at Hamchako, Mutsamudu, Autonomous Island of Anjouan, Union of Comoros. Futuur is licensed and regulated by the Government of the Autonomous Island of Anjouan, Union of Comoros and operates under License No. ALSI-202410061-FI2. Futuur has passed all regulatory compliance and is legally authorized to conduct online gaming operations for any and all games of chance and wagering.<br/><br>Payments may be processed through Futuur Ltd., a subsidiary company with offices at Voukourestiou 25, Neptune House, 1st Floor, Office 11, Zakaki, 3045, Limassol, Cyprus.',
  },

  login_reset: {
    title: 'Login problems?',
    insert_your_email: "Enter your email and we'll send you a recovery link",
    recover: 'Recover',
    invalid_email: 'Invalid email',
    success: 'Password updated',
    reset_password: 'Reset Password',
    new_password: 'New password',
    confirm_password: 'Confirm password',
    toast_success_text: 'Reset email has been sent!',
    invalid_token_param: 'Invalid token param',
    error: 'Token is invalid. Please request password recovery again.',
    password_requirements: {
      more_than_8_chars: 'More than 8 characters',
      must_contain_numbers_and_letters: 'Must contain numbers and letters',
    },
    confirm: 'Confirm',
    deposit: 'Deposit',
    password_changed: 'Password changed!',
    success_message: 'Now login to your account and happy forecasting!',
    login: 'Login',
    email_not_found_error: 'This email is not registered',
  },

  signup: {
    welcome: 'First step to become a forecaster!',
    signin: 'Login',
    signup: 'Sign up',
    first_name: 'First name',
    last_name: 'Last name',
    full_name: 'Full name',
    email: 'Email',
    password: 'Password',
    welcome_to_futuur: 'Welcome to Futuur',
    choose_a: 'Choose a ',
    username_placeholder: 'myusername',
    username_checking: 'Verifying availability…',
    username_error_min_length: 'Use at least ${this.min} characters',
    username_error_max_length: 'Use at most ${this.max} characters',
    username_error_pattern: 'Use only letters, numbers or underscore',
    password_helper_1: 'At least 8 characters with numbers and letters',
    password_helper_2: 'contain numbers and letters',
    password_helper_3: 'at least one special character',
    error_email: 'invalid address',
    error_first_name: 'Must fill your first name',
    error_last_name: 'Must fill your last name',
    error_name: 'Must fill your full name',
    error_too_short: 'must be longer than 8 characters',
    create_account: 'Create Account',
    set_pp: 'Set your profile picture, ',
    continue: 'Continue',
    username: 'Username',
    pick_username: 'Pick Username',
    already_forecaster: 'Already have an account?',
    email_placeholder: 'example@email.com',
    title: 'Futuur ~ Sign Up',
    choose_username: 'Please choose a username',
    you_got_mail: 'Verify your email to activate your account',
    setting_up_account: 'Setting up your account...',
    username_warning: 'It can’t be changed later, choose well',
    choose_profile_picture: 'Please choose a profile picture',
    choose_profile_picture_info: 'You can change at anytime in your account settings',
    account_settings: 'account settings',
    ready_to_predict: 'Ready to Predict',
    proceed: 'Proceed',
    add_picture_later: 'Add picture later?',
    skip: 'Skip for now',
    terms: 'Terms',
    privacy_policy: 'Privacy Policy',
    check_out_1: 'Check out our ',
    check_out_2: ' and ',
    enter_with_email: 'Enter with email',
    verification_info: 'For any uncertainties, consult our ',
    identity_verification_policy: 'identity verification policy',
    proceed_without_verifying: 'Proceed without verifying?',
    verify_later: 'Verify later',
    email_verified: 'Email Verified!',
    time_to_predict_the_future: 'Cool! Now it’s time to start predicting the future!',
    start_forecasting: 'Start Forecasting',
    login_to_your_account: 'Log in to your account',
    account_username_already_taken: 'Account username already taken',
    invalid_link: 'The link you clicked is not valid.',
    go_to_futuur: 'Go to Futuur',
  },

  signin: {
    title: 'Futuur ~ Sign In',
  },

  maintenance: {
    title: 'Futuur is currently down for maintenance',
    text: 'We expect to be back in a couple of hours. Thanks for your patience.',
  },

  tags: {
    meta_tags: {
      title: 'Prediction markets for every topic, powered by the crowd.',
      description: 'Hundreds of prediction markets, with forecasts powered by the wisdom of the crowd.',
    },
  },
  tag: {
    meta_tags: {
      title: '${this.tag} predictions, powered by the crowd',
      description: 'Explore over ${this.marketCount} ${this.tag} prediction markets on Futuur.',
    },
  },
  landing: {
    meta_tags: {
      title: 'Futuur — Prediction Markets for Sports, Politics, Crypto & More',
      description:
        'Trade on real-world events with play money or USDC. Bet on elections, sports, crypto prices, AI milestones and more. Explore over ${this.marketCount} crowd-powered markets.',
    },
    title_line1: 'Predict',
    title_line2: 'the Future',
    hero_text:
      'Futuur is a community-based forecasting game, and a platform for predicting the future using collective intelligence.',
    start_forecasting: 'Start Forecasting',
    view_predictions: 'View Predictions',
    fb_enter: 'Enter with Facebook',
    signup: 'Enter with Email',
    learn_more: 'Learn more',
    watch: 'Watch Video',
    how_it_works: 'How it Works',
    categories_banners: 'Hot topics 🔥',
  },

  how_it_works: {
    hero: {
      eyebrow: 'About Futuur',
      title_line1_a: 'Bet ',
      title_line1_b: '',
      title_line2_a: 'On the',
      title_line2_b: ' Future',
      description:
        'Make money with what you know, or use Ooms, our play money, to build your skills and reputation as a forecaster.',
      cta_primary: 'Get started',
      cta_secondary: 'Explore Markets',
      free_to_start: 'Free to start with play money — no deposit needed.',
      modes_intro: 'Your call:',
      mode_play: 'Play money',
      mode_real: 'Real money · USDC',
      topics_intro: 'Forecast across',
      stats: {
        founded_value: 'Founded 2017',
        founded_label: '· Play money only',
        forecasters_value: '25,000+',
        forecasters_label: 'forecasters',
        events_value: '44,000+',
        events_label: 'events priced',
        brier_value: 'Brier 0.157',
        brier_label: '· Real money',
      },
      scroll: 'Scroll',
    },
    intro: {
      title: 'At Futuur, you can bet on <b>everything</b> <br/> & help generate better forecasts for <b>everybody</b>',
      p1: 'Futuur is a prediction market that harnesses collective wisdom to generate more precise forecasts on diverse subjects.  It offers better insights and rewards for accurate predictions.',
      p2: 'On Futuur, you can bet on the future of just about anything',
      p3: 'Bet for your rep with Play Money, or put some more skin in the game and bet with any of the Major Cryptocurrencies',
      cta: 'join now',
    },
    header: {
      title1: 'Get started forecasting',
      title2: 'in just a few steps',
    },
    step1: {
      title1: 'Sign up',
      title2: ' with email or Google',
      paragraph:
        'Registration is fast and free.  And you’ll get 10,000ø in play-money to kick off your career as a forecaster!',
    },
    step2: {
      title1: 'Add funds',
      title2: ' to bet with real money, or bet for fun with play-money',
      paragraph:
        ' Deposit with your choice of currencies (USD, EUR, BRL, and others), or with crypto. And withdraw whenever you want.',
    },
    step3: {
      title1: 'Choose from',
      title2: ' hundreds of markets to predict',
      paragraph: 'Futuur offers the most real-money markets anywhere, covering pretty much every topic imaginable!',
    },
    step4: {
      title1: 'Start betting',
      paragraph:
        "Market odds mirror the crowd's prediction of an outcome's likelihood, and can be a profit opportunity if you spot a mispricing.",
    },
    join_tips: {
      header1: 'Join a global ',
      header2: 'community of forecasters',
      step1: {
        title1: 'Follow',
        title2: ' the smart money',
        paragraph: 'Find and follow the most prescient predictors on our leaderboard.',
      },
      step2: {
        title1: 'Make your voice ',
        title2: 'heard',
        paragraph: 'Leverage comments for insights and contribute to the discussion.',
      },
      step3: {
        title1: 'Suggest',
        title2: ' markets',
        paragraph: 'Make your suggestion and get a clearer view of the future by leveraging collective intelligence.',
      },
    },
    use_strategy_title: 'Use strategy to bet and win!',
    use_strategy_paragraph:
      'Prices on Futuur are determined by market activity. You can sell buy and sell positions at anytime as prices fluctuate, securing gains without waiting for the event outcome.',
    hot_topic: 'Hot topics to bet 🔥',
    about: {
      ticker_live: 'Live',
      ticker_fallback: {
        f1: 'Browse live markets on Futuur',
        f2: 'Forecast politics, sports, finance and more',
        f3: 'Real-money and play-money markets',
      },
      numbers: {
        events_label: 'Events forecasted',
        events_blurb: 'Real-world questions priced since 2017 — politics, sports, crypto, finance and beyond.',
        forecasters_label: 'Forecasters',
        forecasters_blurb: 'A global crowd putting reputation — and real money — on the line.',
        founded_label: 'Founded',
        founded_blurb: 'Headquartered in São Paulo and live every day since.',
        brier_label: 'Real-money Brier score',
        brier_blurb: 'Lower is better. Real-money markets price the future measurably sharper than play money.',
      },
      manifesto: {
        eyebrow: '01 · Our mission',
        thesis_1: 'Our goal with Futuur is to inform better decision-making by providing ',
        thesis_2: 'more accurate forecasts',
        thesis_3:
          ' across the greatest breadth and depth of topics — from the macro to the micro, the global to the local, the long term to the imminent.',
        author: 'Tom Bennett',
        role: 'Founder & CEO',
        source: 'Hello, Futuur',
      },
      steps_intro: {
        eyebrow: 'How it works',
        title: 'Three steps from question to payout.',
        body: 'Anyone can propose a market. Every market ships with a binding resolution source. Prices move when forecasters trade. When the event happens, correct shares pay $. Wrong shares pay zero.',
        scroll: 'Scroll through steps',
      },
      cards: {
        ask: {
          tag: 'Proposed market · pre-trading',
          title: 'Will the EU pass an AI liability act in 2026?',
          resolves: 'Resolves',
          source: 'Source',
          format: 'Format',
          format_value: 'Binary · Yes / No',
          proposed_by: 'Proposed by',
          yes: 'Yes 38%',
          no: 'No 62%',
        },
        trade: {
          tag: 'Order ticket · USDC market',
          title: 'EU AI liability act in 2026?',
          side: 'Side',
          side_value: 'Buy · Yes',
          size: 'Size',
          size_value: '100 shares',
          avg_price: 'Avg price',
          cost: 'Cost',
          if_correct: 'If correct',
          now: '0.38 now',
        },
        settle: {
          tag: 'Market resolved · 31 Dec 2026',
          title: 'EU AI liability act in 2026?',
          outcome: 'Outcome',
          outcome_value: 'Yes ✓',
          shares_held: 'Shares held',
          shares_held_value: '100 × Yes',
          settlement: 'Settlement',
          settlement_value: '1.00 USDC / share',
          payout: 'Payout',
          profit: 'Profit',
        },
      },
      steps: {
        of_total: '/ 03',
        list_eyebrow: "In this step, we'll cover",
        figurative_note: 'Figurative example only',
        s1: {
          word: 'Ask',
          title: 'Every market begins as a question with a real answer.',
          lede_a: 'Markets on Futuur are written as binary, multi-choice with resolution criteria ',
          lede_em: 'published before trading opens',
          lede_b: ". The crowd answers what the question actually asked, against a source that's named up front.",
          q1: 'What is a prediction market?',
          q2: 'How are markets created?',
          q3: 'What counts as a resolution source?',
          q4: 'Why are some markets cancelled?',
          cta: 'Read the market rules',
        },
        s2: {
          word: 'Trade',
          title: 'Buy shares in the outcome you believe.',
          lede_a: 'Futuur runs every market through an ',
          lede_em: 'automated market maker',
          lede_b:
            ', so you can buy or sell a position instantly. The lower the share price, the bigger the payout if you turn out right. Trade with Ooms (ø) or with real money in USDC.',
          q1: 'How do I place a bet?',
          q2: 'Play Money vs Real Money — what’s the difference?',
          q3: 'How does the automated market maker work?',
          q4: 'Can I cash out before the market resolves?',
          cta: 'View how trading works',
        },
        s3: {
          word: 'Settle',
          title: 'Get paid when you’re right.',
          lede_a:
            'When the event lands, the market settles against the source declared at launch. Winning shares redeem at ',
          lede_em: '1.00',
          lede_b:
            " in the market's currency — USDC or Ooms. Losing shares go to zero. Payouts hit your wallet automatically.",
          q1: 'How does Futuur resolve a market?',
          q2: 'When do I receive my payout?',
          q3: 'Which countries can trade real money?',
          q4: 'How do I withdraw my balance?',
          cta: 'View live markets',
        },
      },
      feature_quote: {
        text_a: 'Under the right circumstances, groups are remarkably intelligent, and are often ',
        text_em: 'smarter than the smartest people in them',
        text_b: '.',
        author: 'James Surowiecki',
        role: 'The Wisdom of Crowds (2004)',
        source: '',
      },
      money_cover: {
        badge: 'Nerd stats',
        title_a: 'How accurate is ',
        title_em: 'Futuur',
        title_b: '?',
      },
      score: {
        eyebrow: 'Calibration · peer-reviewed',
        title_a: 'Money talks.',
        title_b: 'Forecasts ',
        title_em: 'listen.',
        intro_a: 'The largest within-platform study to date — ',
        intro_strong: '19,094 markets · 316,239 transactions · Jan 2020 to Apr 2024',
        intro_b: '. Real money makes the crowd ',
        intro_em: 'measurably',
        intro_c: ' sharper (lower Brier = better).',
        rm_label: 'Real money',
        pm_label: 'Play money',
        brier_lower: 'Brier score · lower is better',
        brier_same: 'Brier score · same period',
        more_accurate: 'more accurate',
        markets: 'markets',
        users_word: 'users',
        txns_each: 'txns each',
        volume_brier: 'volume → Brier < 0.04',
        plateaus: 'Plateaus at Brier ≈ 0.04',
        chart_caption: 'Avg. Brier score by category · real money outperforms in every domain',
        notes: {
          politics_k: 'Politics',
          politics_v: '50% more accurate than the average of other categories (RM markets).',
          sample_k: 'Sample size',
          sample_v: '9,547 matched markets per condition · same questions, same timeframe.',
          sig_k: 'Significance',
          sig_v: 'p = 3.4 × 10⁻⁶ · the gap is not noise.',
          read_k: 'Read it',
          read_v: 'Full paper on the Futuur blog',
        },
      },
      marquee2: {
        m1: '19,094 markets analyzed',
        m2: '316,239 transactions',
        m3: '6.33% sharper with real money',
        m4: 'Since 2017',
      },
      join_us: {
        eyebrow: 'Join us',
        title_a: 'Passionate about ',
        title_em: 'predictions',
        title_b: '? Join us!',
        body: "We're a small, senior team eager to innovate and build things people actually use. Remote-friendly. Plenty of room for impact. If that sounds like a fit, we'd love to talk.",
        cta_primary: 'View all roles',
        photo_alt: 'The Futuur team',
      },
    },
  },
  redeem_code: {
    title: 'Redeem a code',
    redeem: 'Redeem',
    success_message: 'Code applied successfully!',
    code: 'Code',
  },
  comments_feature: {
    play_money_only: '· Play money only',
    reply: 'Reply',
    like: 'Like',
    share: 'Share',
    report: 'Report',
    comment: 'Comment',
    post: 'Post',
    write_your_reply: 'Write your reply',
    share_your_mind: 'Share your mind...',
    more_reply: '1 more reply',
    more_replies: '${this.count} more replies',
    hide_replies: 'Hide replies',
    no_comments_yet: 'No comments yet',
    be_the_first: 'Be the first to share your thoughts on this market',
    comment_deleted: 'This comment was deleted',
    delete: 'Delete',
    delete_comment: {
      modal_header_text: 'Delete comment',
      modal_info_message:
        'This will remove your comment. Replies from other users will remain, shown under a deleted-comment placeholder.',
      action_button_text: 'Delete',
      success_title: 'Comment deleted',
    },
    report_comment: {
      modal_header_text: 'Report',
      input_label: 'Whats happening',
      modal_info_message:
        'Thank you for your report. We will review our community policies to make the best decision and keep our community strong.',
      reason_input_placeholder: 'Explain briefly why you are reporting',
      success_title: 'Thanks for the report',
      success_body: 'We will work to evaluate this issue as quickly as possible.',
      action_button_text: 'Send',
    },
    share_comment: {
      success_title: 'Link copied!',
      success_body: 'The link is ready to share.',
    },
    post_comment: {
      success_title: 'Your comment was posted successfully',
    },
    reply_to_comment: {
      success_title: 'Your reply was posted successfully',
    },
    commented_on: 'commented on',
  },
  feed_banner: {
    Trade_the_future: 'Bet on the Future',
    Future_of_forecasting: 'The future of forecasting',
    intro_text: 'Make money with what you know and help generate better forecasts for everyone.',
    start_forecasting: 'Start forecasting',
    make_your_forecasts: 'Make your forecasts',
  },
  location_not_allowed: {
    title: "Real Money betting isn't available in your region.",
    text_part1: 'You can still view real money forecasts, or click below to make your own predictions in play money.',
    text_part2: 'for more info.',
    portfolio_text_part1:
      'Portfolio is not available. To see your Ooms portfolio, click on your account balance above and select Ooms',
    terms_conditions: 'Terms and Conditions',
    change_play_money: 'Change to Play Money',
  },
  not_enough_funds: {
    content: "You don't have enough funds to place a bet using this currency. Please add funds to make your forecast.",
    text: 'Lorem ipsum dolor sit amet consectetur adip sit biti adip sit amet consectetur adip',
    add_funds: 'Add funds',
    use_another_currency: 'Use another currency? Change ',
    here: 'here',
  },

  infinite_grid: {
    load_more_markets: 'Load more Markets',
    load_more: 'Load more',
    view_all_markets: 'View all markets',
    retry: 'Retry',
  },
  convert_success_modal: {
    see_transaction: 'See transaction',
    view_market: 'View market',
    added_to_balance: 'added to your balance! 🎉',
    conversion_successful: 'Conversion successful',
    conversion_completed: 'Your conversion has been completed successfully',
  },
  login: {
    presentation:
      ' is a community-based forecasting game and platform for predicting the future using collective intelligence.',
    login: 'Log In',
    signup: 'Sign Up',
    or_separator: 'or',
    email_label: 'Email',
    login_to_futuur: 'Welcome back to Futuur!',
    create_your_account: 'Create your account',
    email_invalid: 'Invalid address',
    email_required: 'Please enter your email',
    email_address_placeholder: 'Email',
    continue_submit: 'Continue',
    facebook_sign_in: 'Sign in with Facebook',
    google_sign_in: 'Google',
    continue_with_google: 'Continue with Google',
    facebook_sign_up: 'Sign up with Facebook',
    google_sign_up: 'Sign up with Google',
    signup_with_email: 'Sign up with email',
    password_label: 'Password',
    password_invalid: 'Must be longer than 8 characters and contain numbers and letters',
    login_button: 'Login',
    forgot_password: 'Forgot your password?',
    terms_text1: 'By creating your account, you agree with our ',
    terms_text2: ' and ',
    terms: 'Terms of Use',
    dont_have_account: "Don't have an account ?",
    register: 'Register',
    already_forecaster: 'Already a forecaster ?',
    privacy: 'Privacy Policy',
    wrong_password: `Email and password do not match`,
    invalid_2fa_token: `wrong 2fa code, please make sure you grab the right one`,
    server_failure: 'Server communication failure. Please contact us if it persists.',
    google_error: 'An error occurred while trying to proceed with Google authentication',
    google_error_server: 'An error occurred in our servers while trying to authenticate your Google user on Futuur',
    two_factor_auth: {
      title: 'Authentication code',
      paragraph: 'You can find your code in your authenticator app',
      have_problem: 'Having trouble? Contact our ',
      support: 'Support',
    },
    user_name_changed_success: 'Username changed successfully',
    modal_welcome_title: 'Welcome to Futuur',
    login_via_wallets: 'Continue with Wallet',
    signup_via_wallets: 'Sign up via Wallet',
  },
  page_title: {
    markets: 'Markets',
    explore: 'Explore',
    account: 'Account',
    activity: 'Activity',
    leaderboard: 'Leaderboard',
    followers: 'Followers',
    following: 'Following',
    public_profile: 'Profile',
    prediction_list: 'Predictions',

    question_suggestions: 'Question suggestions',
    question_details: 'Question details',
    category: 'Category',
  },
  category_list: {
    custom_closes_in: 'Closes in',
  },
  navbar: {
    markets: 'Markets',
    portfolio: 'Portfolio',
    settings: 'Settings',
    notification: 'Notifications',
    leaderboard: 'Leaderboard',
    ranking: 'Ranking',
    search: 'Search',
    wallet: 'Wallet',
    search_input: 'Search for predictions',
    mobile_login: 'Login',
    desktop_login: 'Login',
    signup: 'Sign Up',
    enter: 'Enter',
    fb_login: 'Enter',
    add_funds: 'Add Funds',
    deposit: 'Deposit',
  },
  navbar_menu: {
    settings: 'Account Settings',
    my_profile: 'My Profile',
    view_profile: 'View profile',
    wallet: 'Wallet',
    api_docs: 'API Docs',
    theme: 'Theme',
    light_mode: 'Light Mode',
    dark_mode: 'Dark Mode',
    redeem_code: 'Redeem a code',
    copy_user_id: 'Copy user ID',
  },
  bitcoin_tooltip: {
    real_money: {
      title: 'Bet with real money!',
      text1: 'Put some skin in the game by betting with real money.',
    },
    play_money: {
      title: 'Real-Money Markets',
      text1: 'We do not currently offer real-money betting in your jurisdiction.',
      text2:
        'However, you can still view the real-money probabilities (which are not necessarily the same as play-m oney markets) by clicking here.',
    },
    add_funds: 'Add Funds',
    deposit: 'Deposit Now',
    dismiss: 'Dismiss',
  },
  bitcoin_banner: {
    call_to_action: 'Take your predictions to the next level!',
    deposit: 'Deposit with Crypto',
    add_funds: 'Add funds',
    buy_bitcoin: 'Buy Crypto',
  },
  active_markets: {
    title: 'Markets',
    results: 'results',
  },
  go_to_web_version: {
    title: 'Take your predictions to next level!',
    p: 'Deposit with the cryptocurrency of your choice to bet on real-money markets.',
    cta: 'Go to web version',
  },
  faqs: {
    title: 'FAQ',
    link_to_external: "Go to Futuur's documentation",
    what_is_futuur: {
      title: 'What is Futuur?',
      description:
        'Futuur is a prediction market: a crowd-powered platform for generating more accurate predictions about future events. Forecasters make predictions by betting on them using their choice of play money, or crypto. Our mission is to aggregate the wisdom of the crowd to generate better predictions in a chaotic world. You can find out more about Futuur on our <a class="link" href="https://futuur.com/i/how-it-works/">About page</a>.',
    },
    how_are_priced_determined: {
      title: 'How are prices determined?',
      description:
        'Futuur uses an Automated Market Maker (AMM), an algorithm that allows us to provide a buy or sell price for any outcome at any time. This is in contrast with a traditional “order book” approach used, for instance, in a stock market or financial exchange, which requires that both sides of a trade are present at the same time in order for a trade to occur. The AMM approach has the advantage of instant, always-on liquidity for all of our markets, while at the same time maintaining the benefits of dynamic, exchange-based pricing.',
    },
    do_you_have_api: {
      title: 'Do you have a public API?',
      description:
        'Yes! You can view our <a class="link" href="https://docs.futuur.com">API documentation</a> To generate a private key and begin using the API, please go to your Settings page.If you have questions, suggestions, or any other feedback regarding the API, please contact <span class="link">support@futuur.com</span>',
    },
    suggest_a_market: {
      title: 'I have an idea for a market. Where can I suggest it?',
      description:
        'We are always keen to add new and interesting markets to Futuur. If you have a suggestion for a new market, please let us know here: <a class="link" href="https://futuur.com/i/feedback/suggestion" > suggest a market.<a/>',
    },
  },
  settings: {
    title: 'Settings',
    subtitle: 'Manage your account, notifications, security and developer access.',
    create_api_key: 'Create API key',
    profile_section: 'Profile',
    profile_section_hint: 'How you appear to other forecasters on Futuur.',
    account_section: 'Account',
    account_section_hint: 'Notification email, personal information and account removal.',
    notification_email: 'Notification email',
    email_purpose: 'Futuur uses this address for notifications and withdrawal confirmations.',
    email_login_hint:
      'Your current address keeps working until you confirm the new one. After that, the new address becomes your sign-in email and any connected social logins are disconnected.',
    pending_email_title: 'Confirm your new email',
    pending_email_body:
      'We sent a confirmation link to ${this.email}. Your current address stays active until you confirm.',
    new_email: 'New email',
    language_updated: 'Language updated',
    save_failed: "Couldn't save your change. Please try again.",
    preferences_hint: 'Language and appearance.',
    dark_mode_hint: 'Use the dark theme across Futuur.',
    notifications_hint: 'Choose what reaches you, and where.',
    security_hint: 'Keep your account — and your portfolio — locked down.',
    notification_group_push: 'Push',
    notification_group_email: 'Email',
    notification_live_events_hint: 'A market you follow opens for trading.',
    notification_new_followers_hint: 'Someone starts following your forecasts.',
    language_hint: 'Used across the site and in emails we send you.',
    auto_cancel_orders: 'Auto-cancel conflicting orders',
    auto_cancel_orders_hint:
      'When you place a new order, open orders above your remaining balance are cancelled automatically.',
    auto_cancel_orders_enabled: 'Auto-cancel conflicting orders enabled',
    auto_cancel_orders_disabled: 'Auto-cancel conflicting orders disabled',
    password_hint: 'Choose a strong password you do not reuse elsewhere.',
    change_password: 'Change password',
    joined: 'joined ${this.year}',
    meta_tags: {
      title: 'Account Settings | Futuur',
      description:
        'Manage your Futuur account settings, including personal information, security, two-factor authentication, and notification preferences.',
    },
    feedback: 'Feedback',
    contact: 'Contact Us',
    suggest_question: 'Suggest a Market',
    report_bug: 'Report a Bug',
    report_bug_continuation: 'or give a general feedback',
    other_feedback: 'Send Other Feedback',
    rate_app_store: 'Rate in App Store',
    rate_play_store: 'Rate in Play Store',
    about: 'About',
    how_works: 'About Futuur',
    preferences: 'Preferences',
    language: 'Language',
    language_en: 'English',
    language_pt: 'Portuguese',
    account: 'Account',
    logout: 'Logout',
    notifications: 'Notifications',
    notification_live_events: 'Live Events',
    notification_question_resolution: 'Market resolution',
    notification_question_resolution_small: "on a market you've bet on",
    notification_new_followers: 'New Followers',
    notification_comments: 'Comments',
    notification_comments_small: 'on topics you are following',
    contracts: 'Contracts',
    personal_info: 'Personal Info',
    login_security: 'Login & Security',
    payments_payouts: 'Payments & Payouts',
    legal: 'Legal',
    terms_of_use: 'Terms of Use',
    privacy_policy: 'Privacy Policy',
    contest_rules: 'Competition Rules',
    go_to_profile: 'Go to profile',
    edit_profile: 'Edit my profile',
    update_password: 'Update password',
    change_email: 'Change email',
    update_email: 'Update Email',
    invalid_email: 'invalid email address',
    email_same_as_current: 'This is already your current email.',
    your_current_email_is: 'Your current email is',
    send_confirmation: 'Send Confirmation Link',
    use_an_email_address_with_access: "Use an email address that you'll always have access to",
    payment_methods: 'Payment Methods',
    account_settings: 'Account',
    identity_verification: 'Identity Verification',
    faq: 'F.A.Q.',
    faq_continuation: 'Knowledge Base',
    update_personal_info: 'Update Personal Info',
    public_api_section: {
      title: 'API keys',
      key: 'API Key',
      beta_desclaimer:
        'Our Public API allows you to harness the power of the Futuur platform within your own applications, products, or services.',
      link_for_documentation: 'Documentation',
      pending_info: 'We’re validating your request and soon will return via email.',
      request_access: 'Enable API access',
      generate_keys: 'Generate keys',
      public: 'Public',
      private: 'Private',
      delete_keys: 'Delete keys',
      generate_new_keys: 'Generate new keys',
      request_sent_title: 'Request to access Public API done',
      modal_keys_title: 'Public/Private key pair',
      request_sent_description:
        'Congrats, you are now part of the beta API program, and can generate an access key.  Please note that the API program is in beta, and currently provides access to play-money markets only.',
      for_security_reasons:
        ' For security reasons, you can only see your private key once. DO NOT SHARE this key with anyone. If you ever lose your private key, you must generate another public/private key pair.',
      enable_to: 'Once enabled, your key works for both real-money and play-money bets.',
      must_verify: 'Please finish KYC inorder to use real money',
      if_you_lose: 'If you ever lose your private key, you must generate another public/private key pair.',
      choose_scope: 'Choose what this key can trade.',
      replace_warning_title: 'You already have a key pair.',
      replace_warning:
        'Creating a new one replaces it — requests signed with your current keys will stop working immediately.',
      replace_key: 'Replace key',
      scope_play_hint: 'Forecast with ooms (ø). No requirements.',
      scope_real_hint: 'Trade real currencies too.',
      always_included: 'Always included',
      needs_verification: 'Needs identity verification',
      real_money_row: 'Real money trading',
      step_key: 'Key',
      step_your_keys: 'Your keys',
      your_new_key_pair: 'Your new key pair',
      ready_to_use: 'Ready to use immediately.',
      copy_private_now: 'Copy your private key now.',
      active: 'Active',
      revoke: 'Revoke',
      revoke_confirm: 'Revoke this API key? Apps using it will stop working immediately.',
      no_keys_yet: 'No API keys yet. Create one to start trading programmatically.',
      open_docs: 'Open API docs',
      cancel: 'Cancel',
      done: 'Done',
    },
    two_factor: {
      on: 'On',
      off: 'Off',
      pending: 'Pending',
      enabled_toast_title: '2FA enabled',
      enabled_toast_body: 'Some actions such as login will require 2FA from now on',
      disabled_toast_title: '2FA disabled',
      disabled_toast_body: 'You can enable it again anytime.',
      info: 'The two-factor authentication protects your account by requiring a code at login.',
      enable: 'Two-factor authentication',
      disable: 'Disable',
    },
    security_settings: 'Security',
    have_any_further_questions: 'Have any further questions?',
  },
  two_factor_auth_validation: {
    complete: {
      title: 'Two factor added',
      paragraph: 'Two-factor authentication protects your account by requiring a login code when you log in.',
    },
    back: 'Back',
    load_error: "Couldn't load the two-factor setup. Please try again.",
    retry: 'Try again',
    paragraph: 'To activate your two-factor authentication, you need to:',
    step1: 'To active, scan the QR code using Auth apps:',
    step2: 'After scanning the QR, enter the generated token',
    enable: 'Enable 2FA',
    cant_scan_code: "Can't scan? Enter the code below instead",
    add_code: 'Add code',
    code: 'Code',
  },
  update_request: {
    need_update: 'Update Needed',
    update: 'Update',
    title: 'Update Your App to the newest version',
    description:
      'Oops! looks like you have an older version of Futuur. In order to keep safely making predictions, please update.',
  },
  activity: {
    tabs: {
      user: 'Your activity',
      following: 'Forecasters you follow',
    },
    empty_list: "You don't have any notifications yet.",
    searching: "Searching for what's new around here",
    live_now: 'is now live',
    you_got_it_right: 'You got it right!',
    bet_on: 'Bet on',
    resolved_on: 'Resolved on',
    incorrect: 'Incorrect',
    correct_outcome_was: 'Correct outcome was',
    withdraw_success: 'Withdrawal Completed',
    withdraw_request: 'Withdrawal Request Received',
    follow: 'Follow',
    following: 'Following',
    view_profile: 'View Profile',
    canceled: 'has been canceled',
    deposit_completed: 'Deposit Completed',
    deposit_pending: 'Pending Deposit',
    welcome_to_futuur: 'Welcome to Futuur',
    notification_amount_earned:
      'Thanks for registering as a forecaster on Futuur!  In order to access all the features on our platform, please activate your account by clicking on the button on an email we’ve sent.',
    resend: 'Re-send',
    change_email: 'Change Email',
  },
  filters: {
    people_i_follow: 'People I follow',
    hide_my_bets: 'Hide my bets',
    open_markets: 'Open markets',
    resolved_market: 'Resolved markets',
    pending_markets: 'Pending markets',
    status_open: 'Open',
    status_pending: 'Pending',
    status_closed: 'Closed',
    // "Markets"-prefixed variants shown only inside the status dropdown options
    status_open_option: 'Open markets',
    status_pending_option: 'Pending markets',
    status_closed_option: 'Closed markets',
    market_i_follow: 'Markets I follow',
    default_category: 'All categories',
    status: 'Status',
    categories: 'Categories',
    toggle_categories: 'Toggle categories menu',
    trade: 'Trade',
    filter_by: 'Filter by',
    apply: 'Apply',
    others: 'Others',
    reset: 'Reset',
    only: 'Only',
    select_all: 'Select all',
    currencies: 'Currencies',
  },
  calendar: {
    month: 'Month',
    weekday_format: 'EEEEE',
    year: 'Year',
    previous_month: 'Previous month',
    next_month: 'Next month',
  },
  markets: {
    place_bet_column: 'Bet slip',
    select_market_to_bet: 'Pick a market to place a bet',
    select_match_to_bet: 'Pick a match to place a bet',
    view_all_outcomes: 'View all (+${this.count})',
    view_less_outcomes: 'View less',
    more_outcomes: '+${this.count} more',
    minutes_short: 'min',
    hours_short: 'h',
    days_short: 'd',
    view_mode: 'View',
    view_cards: 'Card view',
    view_list: 'List view',
    bet_count_one: '${this.count} bet',
    bet_count_other: '${this.count} bets',
    column_closes: 'Closes',
    column_market: 'Market',
    column_kickoff: 'Kickoff',
    column_match: 'Match',
    column_volume: 'Vol',
    column_probability: 'Probability',
    closes_on_label: 'Closes on ${this.date}',
    kickoff_at_label: 'Kickoff ${this.date}',
    share_market: 'Share market',
    more_options: 'More options',
    follow: 'Follow market',
    following: 'Following',
    all_markets: 'All',
    all_questions: 'All Markets',
    category_trending: 'Trending',
    category_world_cup: 'World Cup 2026',
    category_new: 'New',
    category_all: 'All',
    crypto_price_window_5min: '5 min',
    crypto_price_window_15min: '15 min',
    crypto_price_window_hourly: 'Hourly',
    crypto_price_window_daily: 'Daily',
    category_all_in: 'All in ${this.category}',
    category_more: 'Show more categories',
    no_markets_title: 'No markets found',
    no_markets_filters_hint: 'Try changing or clearing the filters you applied.',
    no_open_events: 'No open events found',
    view_closed_events: 'View closed events',
    title_category_prefix: '',
    title_category_suffix: ' Forecasts and Predictions | Futuur',

    title_meta: 'Forecasts and Predictions | Futuur',
    make_your_forecasts: 'Make your forecasts',
    live_markets: 'Live soon',
    resolved_only: 'Resolved Only',
    resolved_and_sold: 'Resolved And Sold',
    sort_by: 'Order By',
    most_recent: 'Newest',
    bet_end_date: 'Closing soon',
    number_of_bets: 'Most bettors',
    volume: 'Volume',
    relevance: 'Relevance',
    default: 'Default',
    link_copied: "Market's link copied !",
  },
  worldcup: {
    feed_banner_aria: 'FIFA World Cup 2026 promotion',
    feed_banner_badge: 'FIFA World Cup 2026™',
    feed_banner_title_prefix: 'The world is',
    feed_banner_title_highlight: 'Trading',
    feed_banner_title_suffix: 'the Cup.',
    feed_banner_subtitle: 'Every match, every group, one long board. Back your call as the odds move in real time.',
    feed_banner_cta: 'Trade the Cup',
    tab_all_games: 'All games',
    tab_brackets: 'Knockout brackets',
    bracket_title: 'Knockout bracket',
    bracket_tie: 'tie',
    bracket_ties: 'ties',
    bracket_tbd: 'TBD',
    bracket_empty: 'Bracket not available yet',
    bracket_now: 'Now',
    bracket_view_full: 'View bracket',
    groups_knockout_subtitle: 'Knockout stage',
    bracket_prev_round: 'Previous round',
    bracket_next_round: 'Next round',
    bracket_rounds: 'Bracket rounds',
    page_title: 'FIFA World Cup 2026',
    page_subtitle: 'Standings and live matches',
    meta_title: 'FIFA World Cup 2026 | Futuur',
    meta_description: 'Follow FIFA World Cup 2026 group standings and live scores on Futuur.',
    groups_title: 'Groups',
    groups_subtitle: '12 markets · Win group',
    group_detail_title: 'Group standings',
    group_markets_title: 'Group markets',
    group_markets_subtitle: 'Group ${this.group}',
    no_group_markets: 'No markets for this group yet',
    all_markets_tab: 'All',
    all_markets_tab_small: 'markets',
    all_markets_title: 'All markets',
    markets_in_group: 'Markets in Group ${this.group}',
    group_markets_hint: 'match result, red & yellow card, first-scorer props',
    win_group: 'Win group',
    col_team: 'Team',
    col_chance: 'Chance',
    live_title: 'Live matches',
    live_count: 'live',
    soon_count: 'soon',
    live_label: 'live',
    no_live_matches: 'No live matches right now',
    no_upcoming_matches: 'No upcoming match markets yet',
    next_match_title: 'Next match',
    more_upcoming: 'More upcoming matches',
    market_probability: 'Market probability',
    no_goals_yet: 'No goals yet',
    possession: 'Possession',
    shots: 'Shots',
    shots_on_target: 'On target',
    corners: 'Corners',
    live_win_probability: 'Live win chance',
    updates_realtime: 'Updates in real time',
    draw: 'Draw',
    no_standings: 'Standings not available yet',
    general: 'General',
    load_error: 'Unable to load tournament data',
    more_live: 'More live matches',
    other_live: 'Other live markets',
    tap_to_bet: 'tap to bet',
    tap_to_feature: 'tap to feature',
    live_now_label: 'Live now',
    next_live_title: 'Next live matches',
    selected_market: 'Selected market',
    live_match_stats: 'Live match stats',
    tie: 'TIE',
    of: 'of',
    traders: 'traders',
    volume_label: 'volume',
    on_bet_slip: 'On bet slip',
    bets: 'bets',
    chart_unavailable: 'Chart unavailable for this match',
    bet_disclaimer:
      "By placing this order you agree to Futuur's Market rules. Markets settle on the official FIFA result.",
    match_result: 'Match result',
    match_status: {
      not_started: 'Not started',
      first_half: '1st half',
      half_time: 'Half-time',
      second_half: '2nd half',
      break: 'Break',
      extra_time: 'Extra time',
      penalties: 'Penalties',
      full_time: 'Full-time',
      after_extra_time: 'After extra time',
      full_time_penalties: 'Decided on penalties',
      postponed: 'Postponed',
      cancelled: 'Cancelled',
      suspended: 'Suspended',
      interrupted: 'Interrupted',
      abandoned: 'Abandoned',
      delayed: 'Delayed',
      awarded: 'Awarded',
      walkover: 'Walkover',
    },
    backing: 'Backing',
    avg_price: 'Average price',
    shares: 'Shares',
    potential_payout: 'Potential payout',
    place_bet: 'Place Bet · ${this.amount}',
    to_win: 'to win',
    view_market: 'View market',
    hero: {
      photo_placeholder: 'Drop the featured story photo',
      market_move: 'Market move',
      host_nation: 'Host nation',
      upset_watch: 'Upset watch',
      live_now: 'Live now',
      slide1_title: 'Brazil surge to clear Group F favourites after Vinícius brace',
      slide1_sub:
        "A two-goal first half pushed Brazil from 31% to 49% chance to win the group — the day's sharpest move.",
      slide1_mover: 'Brazil · win Group F',
      slide2_title: 'USA pull level with the Netherlands in a frantic Group C night',
      slide2_sub: "Pulisic's equaliser reopens the group as both nations chase a knockout berth on home soil.",
      slide2_mover: 'USA · advance',
      slide3_title: "Morocco's chance to win Group B nearly doubles overnight",
      slide3_sub: "Traders are piling in after the Atlas Lions' draw with Belgium tightened the Group B race.",
      slide3_mover: 'Morocco · win Group B',
    },
  },
  search: {
    input: 'Search ...',
    trending: 'Trending markets',
    trending_topics: 'Trending topics',
    tabs: {
      all: 'All markets',
      categories: 'Categories',
      users: 'Forecasters',
      questions: 'Markets',
      tags: 'Tags',
      topics: 'Topics',
    },
    no_topics_found: 'No topics found that match your search',
    clear_search: 'Clear search',
    meta_tags: {
      title: 'Search results for "${this.term}" | Futuur',
      description: 'Prediction markets matching "${this.term}" on Futuur.',
    },
    result: {
      question: {
        title: 'Markets',
        cta: 'view all markets',
        total: 'markets',
      },
      category: {
        title: 'Categories',
        cta: 'view all categories',
        total: 'categories',
      },
      user: {
        title: 'Forecasters',
        cta: 'view all forecasters',
        total: 'forecasters',
      },
      tag: {
        title: 'Tags',
        cta: 'view all tags',
        total: 'tags',
      },
    },
    empty: {
      title: "Oops didn't see that search coming!",
      description: "Since you didn't find what you were looking for, <br/> please, tell us what you would like to see.",
      suggest_a_market: 'Suggest a market',
    },
    min_required_chars_message: 'Please enter at least 3 characters to perform a search !',
    no_forecasters_found: 'No forecasters found that match your search',
    no_markets_found: 'No markets found that match your search',
    no_categories_found: 'No categories found that match your search',
    no_tags_found: 'No tags found that match your search',
  },
  question_card: {
    my_positions: 'My positions',
    hide_positions: 'Hide my positions',
    show_positions: 'Show my positions',
    my_closed_positions: 'My closed positions',
    my_transactions: 'My transactions',
    my_open_orders: 'My open orders',
    no_funds_yet: 'No funds yet',
    search_here: 'Search here',
    sport_event: {
      live: 'Live',
      versus: 'vs',
      sports: {
        soccer: 'Soccer',
        basketball: 'Basketball',
        american_football: 'American football',
        hockey: 'Hockey',
        baseball: 'Baseball',
        mma: 'MMA',
        boxing: 'Boxing',
        tennis: 'Tennis',
        formula1: 'Formula 1',
        esports: 'eSports',
      },
      extra_time: 'Extra time',
      penalties: 'Penalties',
      first_half: '1st half',
      half_time: 'Half-time',
      second_half: '2nd half',
      full_time: 'Full-time',
      after_extra_time: 'After extra time',
    },
    date: {
      live: 'live now',
      waiting_result: 'Pending Resolution',
      resolved: 'resolved',
      market_resolved: 'Market resolved',
      resolved_on: 'Resolved on',
      cancelled: 'cancelled',
      bet_end_date_in_minutes: 'In ${this.minutes}m',
      bet_end_date_in_hours: 'In ${this.hours}h',
      bet_end_date_in_minutes_and_seconds: 'In ${this.minutes} : ${this.seconds}',
    },
    crypto_price_up_or_down: '${this.asset} Price up or down',
    crypto_window_today: 'Today',
    crypto_window_hours: '${this.hours} hour',
    crypto_window_hours_plural: '${this.hours} hours',
    crypto_window_minutes: '${this.minutes} min',
    crypto_window_hourly: 'Hourly',
    crypto_window_daily: 'Daily',
    crypto_card_title: '${this.asset} up or down?',
    crypto_card_final: 'Final',
    crypto_card_resolved: 'Resolved',
    crypto_card_pending: 'Pending',
    crypto_card_above: 'above the target',
    crypto_card_below: 'below the target',
    crypto_card_closes_in: 'Closes in',
    crypto_card_to_beat_help: 'Up wins if the price closes above this; Down wins if it closes below.',
    crypto_card_cancelled: 'Cancelled',
    countdown: {
      day: 'Day',
      hour: 'Hour',
      min: 'Min',
      sec: 'Sec',
    },
    bets: 'Bets',
    bet: 'Bet',
    show_bets: 'Show bets',
    hide_bets: 'Hide bets',
    traders: 'Traders',
    volume: 'Volume',
    liquidity: 'Liquidity',
    comments: 'Comments',
    stats_in_play_money: 'Play Money Stats',
    stats_in_real_money: 'Real Money Stats',
    bet_on: 'Bet on',
    related_market: 'People also viewed',
    real_brier_score: 'Real Money brier score',
    play_brier_score: 'Play money brier score',
    live_in: 'Live in',
    waiting_result: 'Pending Resolution',
    finished: 'Finished',
    live_now: 'Live Now',
    brier_score_tooltip:
      'The Brier Score is a strictly proper score function or strictly proper scoring rule that measures the accuracy of probabilistic predictions. ',
    unavailable_currency:
      "This market is not available in real money. If you'd like to bet in Ooms, click on your account balance to switch.",
    tooltip_volume_PM:
      'Volume is the amount traded in a market, plus its initial liquidity.  Your are viewing play-money.  To see volume in real-money, please select a real-money option by clicking on your account balance above, in the header.',
    tooltip_volume_RM:
      'Volume is the amount traded in a market, plus its initial liquidity.  It is shown in USD equivalent.',
    forecaster: 'Forecasters',
    volume_explained: 'Amount traded in a market, plus its initial liquity.',
    tooltip_playmoney:
      'You are viewing play-money markets. To view real-money markets, please click on your account balance above and select real-money.',
    tooltip_realmoney:
      'You are viewing real-money markets. To view play-money markets, please click on your account balance above and select play-money.',
    bets_on_the_market: 'Your bets in this market',
    start_date_hour_format: 'in ${this.hours} hour${this.prularHours} and ${this.minutes} minute${this.prularMinutes}',
    start_date_hour_format_minutesOnly: 'in ${this.minutes} minute${this.prular}',
    sufix_start_date_date: 'on ',
    view_bets: 'View Bets',
    positions_in: 'sold positions ',
    currencies: 'currencies',
    bet_history: 'Bet History',
    comments: 'Comments',
    outcomes: 'Outcomes',
    ends_in: 'Ends ',
    closed: 'Closed',
    view_all: 'View all',
  },
  question_summary: {
    market_rules: 'Market Rules',
    event_details: 'Event details',
    about: 'About this question',
    end_date: 'Bet end date',
    event_start_date: 'Event start date',
    at: 'at',
    activities: 'Activities',
    activity: 'Activity',
    transactions: ' Transactions',
    forecasters: ' forecasters',
    transaction_count: {
      transactions: '${this.transactions} transactions',
      forecasters: ' from ${this.forecasters} forecasters',
      transaction: '1 transaction',
      forecaster: ' from 1 forecaster',
    },
    in_play_money: 'in Play Money',
    in_real_money: 'in Real Money',
    tags: 'Tags',
    feedback: 'Feedback',
    suggested_by: 'Suggested by',
    what_are_your_thoughts: 'What are your thoughts?',
    feedback_modal_header: 'Market feedback',
    feedback_modal_input_placeholder: 'Type here',
  },
  bet_status: {
    transactions: 'Transactions',
    transaction: 'Transaction',
    bet_info: 'Bet Info',
    sell_now: 'Sell',
    buy_more: 'Buy More',
    you_sold: 'You sold your position',
    disabled: 'was disabled',
    shares: 'shares',
    share: 'share',
    open: {
      bet: 'Your bet',
      win: 'If you win',
      sell: 'If you sell now',
    },
    closed: {
      bet: 'You bet on',
      won: 'You Won!',
      lost: 'You Lost',
    },
    sell: 'Sell',
    go_to_market: 'Go to market',
    of: 'of',
    at: 'at',
  },
  bet: {
    your_bet: 'Your bet',
    sold_for: 'Sold for',
    pending_result: 'Pending',
    pending_info: 'The betting period has ended, and the results will be verified.',
    bet: 'Bet',
    sold: 'Sold',
    last_sell_amount: 'Sold for',
    profit: 'Profit',
    won_amount: 'Won',
    you_lost: 'Lost',
    question: 'Market',
    follow: 'You are now following',
    unfollow: 'You unfollowed',
    follow_market: 'You are now following the market',
    unfollow_market: 'You have unfollowed the market',
    reviewing: 'Reviewing',
    cancelled: 'Cancelled',
    reversed: 'Reversed',
    closed: 'Closed',
    paused_info: 'We are analyzing this market. Users with active bets will be notified in case of closure.',
    last_update: 'Last at',
    active: 'Active',
    status: 'Status',
    market: 'Market',
    current_value: 'Current value',
    now: 'Now',
    amount_on_win: 'To win',
    last_transaction: 'Last transaction',
    close_date: 'Close date',
    amount: 'Amount',
    paid: 'Paid',
    market_column_info: 'The market you bet on, with your position and the shares you hold.',
    avg_price: 'Avg. price',
    transactions: 'History',
    no_transactions: 'No transactions found',
    date: 'Date',
    newest_date: 'Newest date',
    oldest_date: 'Oldest date',
    trade: 'Trade',
    outcome: 'Outcome',
    to_win: 'To win',
    closed: 'Closed',
    min_to_receive: 'Min to receive',
    open_orders: 'Orders',
    price: 'Price',
    cancel: 'Cancel',
    price_per_share: 'Price/share',
    buy: 'Buy',
    sell: 'Sell',
    up: 'Up',
    down: 'Down',
    action: 'Action',
    no_active_bets: 'No active bets',
    no_closed_bets: 'No closed bets',
    received: 'Received',
    received_help: 'Payouts from positions you won plus what you got for positions you sold.',
    closed_positions_help: 'Realized profit: what you received from closed positions minus what you paid for them.',
    no_open_orders: 'No open orders',
    no_bets_available: 'No active positions yet',
    place_bet_to_see_here: 'Place a bet to see it here.',
    shares: 'Shares',
    expiration_date: 'Expiration date',
    expiration: 'Expiration',
    in: 'In',
    day: 'day',
    days: 'days',
    filled: 'Filled',
    expired: 'Expired',
    sell_for: 'Sell for',
    active_purchases_amount: 'Amount',
    bet_end_date: 'Close date',
    selling_desclaimer: 'This value shows the amount you can sell your shares for now, based on current buy orders.',
    expiration: 'Expiration',
    cancel_order_modal_title: 'Do you want to cancel ${this.side} order?',
    buy: 'buy',
    sell: 'sell',
    min_to_receive: 'Min. to receive',
    min_to_pay: 'Min. to pay',
    trade: 'Trade',
    total: 'Total',
    setup_email_modal: {
      title: 'Stay in the loop — market updates by email',
      description:
        'Get updates on market outcomes, followers, and comments. You can turn these off anytime in settings.',
    },
  },
  sell_bet: {
    generic_error: 'Error while loading bet. Please try again.',
    not_auth: 'User not authenticated. Please login.',
    bet_sold: 'You just sold your position for ${this.amount} ${this.currency}',
  },

  bet_sell_panel: {
    confirm: 'Confirm',
    selling: 'Selling',
    selling_for: 'Selling for',
    loss: 'Loss',
    profit: 'Profit',
    confirm_new_prices: 'Confirm new prices',
    prices_changed: 'Prices changed, please confirm',
  },

  transaction_card: {
    won: 'Won',
    sold: 'Sold',
    lost: 'Lost',
    open: 'Bet',
    canceled: 'Canceled',
    reversed: 'Reversed',
    pending_result: 'Pending result',
    sold_for: 'Sold for',
    partial_sell: 'Partial Sell',
    bet_amount: 'Bet Amount',
    bet_on: 'Bet on',
    date_time: 'Date',
    user: 'User',
    currency: 'Currency',
    action_outcome: 'Action',
    amount: 'Amount',
    anonymous: 'Anonymous',
    withdrawal_request: 'withdrawal',
    credit: 'Credit',
    deposit: 'Deposit',
    wager_cancellation: 'Market Cancelled',
    wager_reversion: 'Resolution Review',
    initial_balance: 'Initial Balance',
    fees: 'Fees',
    other: 'Other',
    completed: 'Completed',
    processing: 'Processing...',
    pending_confirmation: 'Pending email confirmation',
    resend_email: 'Resend email',
    or: 'Or',
    cancelWithdraw: 'Cancel this withdraw',
  },
  bet_card: {
    bet: 'Bet',
    on: 'on',
    sold: 'Sold',
    position: 'position',
    return: 'return',
    profit: 'Profit',
    loss: 'Loss',
    bought: 'bought',
    sold_bet: 'sold',
    won: 'won',
    lost: 'lost',
  },
  question_details: {
    latest_bets: 'Latest Bets',
    price_history: 'Analysing',
    price_chart_times: ['1D', '1W', '1M', '3M', '1Y'],
    filter_following: 'Filter following',
    user_and_outcome: 'User and outcome',
    amount_bet: 'Shares',
    price: 'Price',
    predictions_cta: 'View all predictions',
    meta_tags: {
      title_prefix: '',
      title_suffix: ' Predictions and Bets',
      outcome_chance: ' &ldquo;${this.outcome}&rdquo; has a ${this.chance}% chance of occurring',
      description:
        'Explore the latest ${this.subcategory} predictions powered by the crowd, and make your own bet on the future.',
    },
    sidebar_title: 'Predict',
    sidebar_subtitle: 'the Future',
    sidebar_about:
      'Futuur is a marketplace for predictions about the future. Sports, politics, entertainment, ' +
      'finance, everything! Show your knowledge and try to to be the best forecaster in the world!',
    sidebar_fb: 'continue with facebook',
    sidebar_video: 'watch video',
    sidebar_hiw: 'How does Futuur work ?',
  },

  place_bet: {
    market_stopped: 'Market stopped',
    market_cancelled: 'Market cancelled',
    outcome_unpriced: 'Odds unavailable',
    outcome_unpriced_description: 'This outcome has no price in the currency you are trading.',
    your_bet: 'Your bet',
    price_per_share: 'Price per share',
    average_price: 'Avg',
    amount: 'Amount',
    bet: 'Bet',
    if_you_win: 'If you win',
    place_bet: 'Place bet',
    matching: 'matching',
    shares_matching: 'shares matching',
    shares_from_order_executed: 'shares from this order will be executed directly',
    fee_includes: 'Includes fee of ${this.amount}',
    no_fees_resting: 'No fees for resting orders.',
    matching_orders_fee: 'Matching orders fee: ${this.amount}.',
    select_bet: 'Select an outcome',
    share: 'share',
    buy: 'Buy',
    sell: 'Sell',
    invalid_number: 'Invalid amount',
    invalid_shares: 'Enter a valid number of shares',
    insufficient_funds: 'Not enough funds',
    from_forbidden_country: 'You can only bet using Play Money (Ooms),',
    max_one_price_per_share:
      'Potential winnings are lower than your bet amount. Please adjust your bet amount to ${this.max} or select a diffrent outcome',
    amount_beyond_max: 'Maximum bet is ',
    amount_below_min: 'Minimum bet is ',
    outcome_not_selected: 'Please select an outcome',
    add_funds: 'Add funds',
    outcome: 'Outcome',
    reset: 'Reset',
    fix: 'Fix',
    loading: 'Loading...',
    confirm_new_prices: 'Confirm price change',
    prices_have_changed: 'Prices have changed, please confirm',
    wager_balance_not_enough: 'Your balance is not enough',
    wager_amount_invalid: 'Oops! Outdated values. Please refresh page',
    wager_max_shares_per_wager: 'Sorry, you have reached the max shares per wager ',
    add_real_money: 'Add real money',
    btc_equivalent_popup:
      'You are betting using ${this.coin}. USD equivalent amounts are shown for your convenience. Please note that the "if you win" amount is guaranteed in the currency used to bet, and may have a different USD equivalent value due to changes in exchange rate.',
    login_required: 'Please login or register to make a bet',
    you_placed_a_bet: 'You have <b>${this.count} open bets</b> in this market, would you like to make another?',
    bet_again: 'Bet again',
    resolved_market: 'This market is resolved. it is impossible to place bets on this market for now.',
    resolution: 'Resolution',
    resolved: 'Market Resolved',
    canceled: 'Market Cancelled',
    reason: 'Reason',
    cancelation_date: 'Cancelled on',
    this_market_is: 'This market is ',
    you_will_recieve_notification:
      'If you have open bets on it, you will receive a notification once it has been resolved.',
    errors: {
      amount_invalid: 'The amount you provided is not valid. Please check and try again.',
      balance_not_enough:
        'Your account balance is not sufficient to complete this transaction. Please add funds or adjust your transaction amount.',
      user_email_not_confirmed:
        'Your email address has not been confirmed yet. Please check your email and follow the instructions to confirm your email address.',
      question_closed: 'The market you are trying to access is closed. Please try another market.',
      max_shares_per_wager:
        'You have exceeded the maximum number of shares allowed for this wager. Please adjust your share count and try again.',
      wager_action_duplicated:
        'Your wager has just been processed. Please wait for 5 seconds before making another bet.',
      balance_not_enough_with_opened_withdrawals:
        'Your account balance is not sufficient to complete this transaction because there is a pending withdrawal request. Please cancel or complete the withdrawal request before trying again.',
      bets_blocked:
        'You are currently block for making new bets. Please finish your Identity Verification on your Account Settings.',
      invalid_hmac_key: 'The security key provided is invalid. Please check and try again.',
      real_money_bet_not_allowed:
        'Real money bets are not allowed. Please choose another type of bet or contact customer support for assistance.',
    },
    bet_made: 'You just made a bet of',
    bet_sell: 'You just sold your bet for',
    bought: 'Bet placed!',
    sold: 'Bet Sold!',
    view_market_details: 'View details',
    pause_title: 'Market under evalutation',
    pause_description:
      'This market is being <b>assessed by our team.</b></br> If you have placed a bet, you will be notified in case if the market be cancelled.',
    yes: 'Yes',
    no: 'No',
    up: 'Up',
    down: 'Down',
    trade: 'Trade',
    sell_now: 'Sell now',
    sell_for: 'Sell for',
    beyond_max_shares: 'Insufficient shares',
    below_min_shares: 'below minimum',
    login_to_bet: 'Login',
    deposit_to_bet: 'Deposit',
    market_resolved: 'Market Resolved',
    limit_order: 'Limit Order',
    limit_price: 'Limit Price',
    use_limit_order: 'Use Limit Order',
    limit_order_info: 'Your order will be executed only when the price reaches your specified limit',
    limit_order_placed: 'Limit order placed',
    limit_order_executed: 'Your limit order has been executed',
    limit_order_expires: 'Expires',
    limit_order_expired: 'Limit order expired',
    limit_order_cancel: 'Cancel Order',
    limit_order_cancelled: 'Limit order cancelled',
    limit_order_pending: 'Limit order pending',
    market: 'Market',
    limit: 'Limit',
    buy: 'Buy',
    to_win: 'To win',
    cost: 'Cost',
    max_to_pay: 'Max to pay',
    fee: 'Fee',
    rebate: 'Rebate',
    rebate_tooltip_before: 'On all Futuur markets, when a taker fills your order, ',
    rebate_tooltip_after: ' of the fee comes back to you as a rebate. Automatic and instant.',
    shares: 'Shares',
    add_expiration_date: 'Add expiration date',
    expiration_date: 'Expiration date',
    no_expiration: 'None',
    place_order: 'Place Order',
    confirm_order: 'Confirm Order',
    until_cancelled: 'Until cancelled',
    end_of_day: 'End of day',
    custom: 'Custom',
    select_expiration_date: 'Select expiration date',
    confirm: 'Confirm',
    min_to_receive: 'Min to receive',
    limit_price_too_high: 'Limit price cannot exceed 0.99',
    no_open_positions: 'No open positions',
    all_shares_committed_to_orders: 'All your shares are committed to open orders',
    create_limit_order: 'Create limit order',
    no_market_sell_available: 'No market sell available',
    no_orderbook_enabled: 'This market has no order book, so selling is unavailable.',
    place_limit_order: 'Place limit order',
    placing_order: 'Placing order',
    try_limit_order_instead: 'Try a limit order instead.',
    market_sell_disclaimer: 'Market sells are filled against the open buy orders in the order book, at the best available prices.',
    limit_sell_disclaimer: 'Your shares are only sold when someone buys at your limit price or better. The order stays open until it is filled, expires or is cancelled.',
    learn_more: 'Learn more',
    convert_disclamer:
      'Futuur is going stablecoin-only (USDC) to boost liquidity and cut fees. Convert to make new bets.',
    convert: 'Convert',
    amount_beyond_orderbook_max: '${this.max} available in the order book.  For larger trades, use Limit Order.',
    no_orders_available: 'No orders available',
    change_to_limit_order: 'Limit order',
    order_update: 'Order Update',
    order_conflict_description:
      'If you place this bet, your balance will be reduced and open orders that exceed your new balance will be cancelled.',
    order_conflict_options:
      'To maintain your open orders, deposit more funds — or proceed and allow them to be cancelled.',
    sell_order_conflict_description:
      'You have insufficient shares to maintain all open sell orders. If you proceed, one or more open sell orders for this position will be cancelled, beginning with the highest-priced orders.',
    dont_ask_again_always_cancel: "Don't ask again, always cancel.",
    deposit: 'Deposit',
    back: 'Back',
    sell: 'Sell',
    real_money_betting_not_available: "Real money betting isn't available in this market",
    change_to_play_money_to_place_a_bet: 'Change to play money to place your bets',
    change_to_play_money: 'Change to play money',
    setup_email_modal: {
      title: 'Stay in the loop — market updates by email',
      description:
        'Get updates on market outcomes, followers, and comments. You can turn these off anytime in settings.',
    },
  },
  positions_timeline: {
    rebate: 'Rebate',
    at: 'at',
    today: 'Today',
    yesterday: 'Yesterday',
  },
  order_book: {
    title: 'Order book',
    description: 'Buy or sell orders that have been placed but not yet executed.',
    hide: 'Hide order book',
    show: 'Show order book',
    last_price: 'Last: ${this.price}',
    spread: 'Spread: ${this.price}',
  },
  place_bet_success: {
    success: 'Success!',
    bet_on: 'Bet on',
    market: 'Market',
    your_bet: 'Your bet',
    average_price: 'Average price',
    if_you_win: 'If you win',
    confirm_new_prices: 'Confirm price change',
    prices_have_changed: 'Prices have changed, please confirm',
    share_your_bet: 'Share your bet',
  },

  question_bet: {
    place_bet: 'Place Bet',
    shares: 'Shares',
    price: 'Price',
    fb_enter: 'continue with facebook',
    email_enter: 'Sign up with email',
    average_price: 'Avg. share price',
    if_you_win: 'If you win',
    your_bet: 'Your bet',
    not_enough_funds: 'Not enough funds',
    add_funds: 'Add funds',
    nowWorth: 'Now worth',
    returnProfit: 'Profit / Loss',
    confirm_prices: 'Confirm new prices',
    prices_have_changed: 'Prices changed, please confirm',
  },
  public_make_bet: {
    text1: 'In order to place bets, please register',
    fb_enter: 'continue with facebook',
    email_enter: 'Sign up with email',
    login_enter: 'Already a forecaster?',
    login_enter_cta: 'Sign in',
  },
  public_follow: {
    text1: 'To follow',
    text2: '— and all other forecasters on Futuur —',
    text3: 'you have to be one of our registered forecasters.',
    fb_enter: 'continue with facebook',
    email_enter: 'Sign up with email',
    login_enter: 'Already a forecaster? ',
    login_enter_cta: 'Sign in',
  },
  question_item: {
    wager: {
      your_bet: 'Your bet',
      if_sell: 'If you sell now',
      sell: 'Sell',
      if_win: 'If your outcome occurs',
      math_details: 'Math Details',
      correct_prediction: 'You hit it right!',
      wrong_prediction: 'You hit it wrong!',
    },
  },
  prediction_card: {
    cta: 'share this prediction',
    paid: 'Price paid',
    total: 'Total bet',
    earnings: 'Earnings',
    losses: 'Loss',
    question_link: 'view question details',
    resolved_date: 'resolved on ',
    cancelled_date: 'cancelled on ',
    correctly_predicted: 'correctly predicted',
    incorrectly_predicted: 'incorrectly predicted',
  },
  math_details: {
    bet: {
      title: 'Your bet',
      card: 'You spent on',
      description:
        'You bought a total of <em>${this.shares}</em> shares from <em>${this.outcome}</em>, ' +
        'spending <em>${this.value}ø</em>.',
    },
    sell: {
      title: 'If you sell now',
      card: "You'll receive",
      current_price: 'Current price',
      tax: 'Tax*',
      receive: "You'll receive",
      profit: 'Profit',
      description:
        '<em>Tax</em>. A tax is applied to the final value of your purchase. This tax varies ' +
        'proportionally of how much your bet impacts the outcomes prices.',
    },
    win: {
      title: 'If your outcome wins',
      title_won: 'Your prediction was right',
      title_lost: 'If your prediction were right',
      card: "You'll receive",
      card_won: 'You received',
      card_lost: 'You would receive',
      receive: "You'll receive",
      receive_won: 'You received',
      receive_lost: 'You would receive',
      spent: 'Ooms spent',
      profit: 'Profit',
      description1:
        '<em>Your Shares</em>. If your prediction is correct, the ${this.shares} shares you purchased ' +
        'will be converted to ${this.amount_on_win}ø. The amount of Ooms you receive is always equal to the amount of ' +
        'shares you had purchased rounded down.',
      description2:
        '<em>Ooms spent</em>. This is the amount of Ooms you originally spent in your purchase. ' +
        'This information can help you calculate your profit.',
    },
    button: 'Ok, Got it',
  },
  prediction_list: {
    prediction: 'predictions',
    share: 'shares',
    price: 'price',
    badge: 'sold',
    filter_all: 'all players',
    filter_following: 'forecasters you follow',
  },
  portfolio_wallet_entry: {
    active_bets: 'Active bets',
    value_active_bets: 'Value of Active Bets',
    value_invested: 'Value invested',
    current_profit: 'Profit',
    return: 'Return',
    current_value: 'Current Value',
  },
  portfolio: {
    header: 'Portfolio',
    meta_tags: {
      title: 'My Portfolio | Futuur',
      description:
        'Track your active and resolved predictions, monitor your positions, and manage your forecasts all in one place on Futuur.',
    },
    add_funds: 'Add Funds',
    active_bets_in: 'Active bets in ',
    past_bets_in: 'Resolved and sold bets in ',
    real_money: 'Real Money',
    play_money: 'Play Money',
    view_wallet: 'View your wallet',
    rebate_program: 'Rebate Program',
    value_of_active_bets: 'Value of Active Bets',
    add_funds_real_money: 'Add funds to place bets in real-money',
    add_funds_or_switch: 'or switch to Ooms to see your bets in play-money',
    view_markets: 'View markets',
    no_bets_in_real_money: 'You have no bets',
    no_bets_paragraph: 'Check our markets and find the most profitable for you',
    select_currency: 'Select Currency',
    tabs: {
      active: 'Open',
      closed: 'Closed',
    },
    summary: {
      value: 'Value of active bets',
      size: 'Active bets',
    },
    filter: {
      title: 'Bets in',
      sort: 'Sort & Filter',
      active: 'Active bets',
      past: 'Past bets',
    },
    card: {
      active_bets_in: 'Active Bets in',
      active_bet_in: 'Active Bet in',
      past: 'Past Bets',
      last30: 'Last 30 Days',
      active: 'Active Bets',
      resolved: 'Resolved or Sold',
      rate: 'Win Rate',
      current_profit: 'Profit',
      return: 'Return',
      value_invested: 'Value Invested',
      value_active: 'Value of Active Bets',
      add_funds: 'Add funds',
      wallet_BTC: 'Bitcoins Wallet',
      wallet_OOM: 'Ooms Wallet',
    },
    all_currencies: 'All Currencies',
    check_it_out: {
      title: 'Check out our new and improved Portfolio! 🔮',
      paragraph:
        'Now with <b class="font-bold">new filters</b> and a more <b class="font-bold">functional tabular view.</b>',
      button: 'Check it out',
    },
    last_30_days: 'Last 30d',
    most_bet_category: 'Most bet-on category',
    you_have_no_bets: 'You have no Open bets',
    bet_on_hot_topic: 'How about bet on our Hot Topics? 🔥',
    life_time: 'Life time',
    win_rate: 'Win rate',
    bet_placed: 'Bets placed',
    ranking: 'Ranking',
    search_placeholder: 'Search in portfolio',
  },
  portfolio_summary: {
    active_bets_singular: 'Active Bet',
    active_bets_plural: 'Active Bets',
    in: 'in',
    play_money: 'Play Money',
    real_money: 'Real Money',
  },
  profile: {
    no_open_positions_title: 'No open positions',
    no_open_positions_description: 'Positions on live markets show up here as soon as there is a forecast.',
    no_transactions_title: 'No transactions yet',
    no_transactions_description: 'Buys and sells show up here as soon as there is activity.',
    end_of_list: "You've reached the end of the list",
    view_markets: 'View markets',
    follow_action: 'Follow',
    following_action: 'Following',
    invite_friends: 'Invite Friends',
    net_worth: 'Net Worth',
    number_of_bets: 'Bets in ${this.currency}',
    win_rate: 'Win Rate',
    total_wagers: 'Total Wagers',
    followers: 'Followers',
    following: 'Following',
    value_active_bets: 'Value of active bets',
    sell_all: 'Sell all active wagers',
    no_bets: 'No bets',
    bet: 'bet',
    bets: 'bets',
    bets_data_title: '${this.currency} Bet Data',
    sell_all_question: 'Sell all wagers?',
    account_settings: 'Account settings',
    no_users: 'No users found',
    restricted_panel_title: 'Bet History for Real Money wagers is not available',
    restricted_panel_text:
      "To view this user's Bet History in Play Money, click on your Account Balance and select Ooms.",
    meta_tags: {
      public_title: ' on Futuur',
      description_outcome:
        "See ${this.username} latest predictions on Futuur.  ${this.username} bet on &ldquo;${this.outcome}&rdquo; on the question &ldquo;${this.question}&rdquo;.  Check out ${this.username}'s other predictions and make your own for free on Futuur.  Better predictions using the wisdom of the crowd.",
      description_no_outcome:
        'See ${this.username} latest predictions on Futuur. Bet on the future of everything, from sports to politics and beyond.',
    },
    anonymous: 'Anonymous',
    open_positions: 'Open positions',
    life_time_profit_loss: 'Lifetime profit/loss',
    lifetime_profit_loss: 'Profit',
    market_traded: 'Markets traded',
    markets_traded: 'Markets traded',
    joined: 'Joined',
    all_time_profit: 'All-time profit',
    markets: 'Markets',
    markets_count: '${this.count} markets',
    top_percentile: 'Top ${this.percentile}%',
    edit_profile: 'Edit profile',
    share_profile: 'Share',
    edit_image: 'Edit image',
    upload_image: 'Upload image',
    update_image: 'Update image',
    change_username: 'Change username',
    change_username_hint: 'Your profile link changes too. Links with your old username keep working until someone else takes it.',
    edit: {
      bio: 'Bio',
      bio_placeholder: 'Add something...',
      social_media: 'Social media',
      instagram: 'Instagram',
      instagram_placeholder: 'username',
      facebook: 'Facebook',
      facebook_placeholder: 'username',
      linkedin: 'LinkedIn',
      linkedin_placeholder: 'username',
      twitter: 'Twitter',
      twitter_placeholder: 'username',
      website: 'Website',
      website_placeholder: 'https://yoursite.com',
      save: 'Save',
    },
  },
  email_confirmation_required: {
    resend_email: 'Send Verification Email',
    change_email: 'Change Email',
    send_again: 'Send Again',
    you_need_verify_email: 'Please verify your email in order to place bets',
    confirmation_required_text: `For security reasons we need you to verify your email. We will also use this email address to send updates
    about your positions. You can adjust your notifications on your preferences.`,
    make_sure_to_check: 'Make sure to check junk or spam folder.',
    sender_is: 'Sender is info@futuur.com',
    email_verified: 'Email Verified!',
    email_verified_from_another_account: 'Email verified from another account',
    email_verified_from_another_account_msg:
      "Please log in from the verified email account to use all Futuur's functionalities.",
    invalid_token: 'Invalid activation URL',
    time_to_predict_future: `Now it's time to predict the future!`,
    start_forecasting: 'Start Forecasting',
    back_to_login: 'Go Back to Login',
    modal: {
      title: 'Verify your email',
      description: 'Verify you email to set up your account and start betting. Check your spam inbox',
      button: 'Resend email',
      sent_title: 'Email sent!',
      sent_description: 'Remember to check the spam folder',
    },
  },
  notifications: {
    market_is: 'Market is',
    cancelled: 'Cancelled',
    live: 'Live',
    you: 'You ',
    the_bot_on: 'the bet on ',
    for: 'for',
    commented: 'commented',
    lost: 'lost',
    won: 'won',
  },
  email_sent: {
    you_got_mail: "You've got mail",
    please_check_your_inbox: 'Please check your inbox and verify your account in order to place bets.',
  },
  leaderboard: {
    meta_tags: {
      title: 'Top Forecasters on Futuur',
      description: 'Check out the best forecasters on Futuur. Better predictions, driven by the wisdom of the crowd.',
    },
    this_week: 'This Week',
    this_month: 'This Month',
    last_month: 'Last 30 days',
    last_day: 'Last 24 hours',
    last_7days: 'Last 7 days',
    all_time: 'All Time',
    all_categories: 'All Categories',
    user: 'Forecaster',
    total_wagers: 'Total wagers',
    earnings: 'Earnings',
    net_worth: 'Net Worth',
    leaderboard: 'Leaderboard',
    description: 'Our rankings consider the profit and loss from',
    tooltip:
      'Our ranking is based on realized profit from resolved markets and sold positions summed to the active ' +
      'bets current worth. All amounts are in Ooms (ø), Futuur’s play-money currency.',
    in: 'in',
    all: 'All Markets',
    hot_market: 'Hot markets',
    see_all: 'See all markets',
    sign_up_or_login: 'Sign up or login to participate',
    eyebrow: 'Forecaster rankings',
    sub: 'The best forecasters on Futuur, as measured by realized profit for the period. Includes only play-money activity.',
    rank: 'Rank',
    profit: 'Profit',
    win_rate: 'Win rate',
    top_category: 'Top category',
    your_rank: 'Your rank',
    find_market: 'Find a market to forecast',
    tf_day: '24h',
    tf_week: '7d',
    tf_month: '30d',
    tf_all: 'All time',
    tf_custom: 'Custom',
    resolved: 'Resolved',
    roi: 'ROI',
    soon: 'Soon',
    soon_hint: 'This stat is coming soon.',
    empty: 'No forecasters ranked for this period yet.',
    custom_period: 'Custom period',
    competition_window: 'Competition',
    competition_range: '${this.start} – ${this.end}',
    competition_since: 'Since ${this.start}',
    competition_sub: 'Standings for this competition, measured by realized play-money profit inside its dates.',
    updated: 'Updated ${this.when}',
  },
  user_ranking: {
    forecater_rank: 'Forecaster rank',
    life_time_profit: 'Profit',
    go_to_profile: 'Go to my profile',
  },
  contracts: {
    terms_title: 'Terms of Use',
    privacy_title: 'Privacy Policy',
    contest_rules_title: 'Competitions Rules',
  },
  feedback: {
    header: 'How can we help?',
    sent_message: 'Feedback sent. Thanks!',
    subheader: 'Pick a topic and send us a note — our team reads every message.',
    form: {
      inputs: {
        topic: {
          label: 'Topic',
          placeholder: 'Select a topic',
        },
        message: {
          label: 'Message',
          placeholder: 'Type here ...',
        },
        market_title: {
          label: 'Market title',
          placeholder: 'Type here ...',
        },
        attachment: {
          section_label: 'Attachment',
          optional: 'optional',
          label: 'Add a screenshot or file',
          drop_your_attachment_here: 'Drop your attachment here',
          accepted_file_types: 'Accepted file types: jpg, jpeg and png',
          validation: {
            invalid_file_type_toast_title: 'The file (${this.name}) type (${this.type}) is invalid',
            invalid_file_type_toast_body:
              'Please upload files of type (.png,.jpg,.jpeg,.txt,.pdf,.doc,.docx,.mp4)',
            invalid_file_size_toast_title: 'The file (${this.name}) size (${this.size}) is too big',
            invalid_file_size_toast_body: 'Please upload files less or equal to 2.5 MB',
            max_files_number_exceeded_toast_title: 'The number of maximum allowed files number exceeded',
            max_files_number_exceeded_toast_body: 'Please upload up to 3 files at maximum',
          },
        },
      },
      topics: {
        general_feedback: 'General Feedback',
        bug_report: 'Bug Report',
        market_suggestion: 'Suggest a Market',
        message_us: 'Message us',
      },
      submit: 'Send',
      validation: {
        name_required: 'Please enter your name',
        email_required: 'Please enter your email',
        email_invalid: 'Please enter a valid email',
        message_required: 'Please enter a message',
        market_title_required: 'Please enter a market title',
      },
    },
    wallet_user_section: {
      contact_us_by_email:
        "Contact us directly by email, send it to <span class='font-bold'>support@futuur.com</span> \n \n Or, link an email to your account <a href='${this.link}' class='!text-[var(--color-brand-04)]'>here</a> and send us messages at anytime directly from the website.",
    },
    sidebar: {
      reach_title: 'Other ways to reach us',
      email_label: 'Email',
      discord_label: 'Discord',
      discord_sub: 'Join the community',
      x_label: 'X / Twitter',
      help_title: 'Popular help articles',
      help_faq: 'FAQ',
      help_how_it_works: 'How Futuur works',
      help_market_maker: 'Market Maker Rebate',
      help_terms: 'Terms of Service',
      help_privacy: 'Privacy Policy',
    },
  },
  app_rate: {
    title: 'Show us your love!',
    text: 'Enjoying Futuur? If yes, we kindly ask you to take a moment to rate 5 star in the App Store! ',
    confirm: 'yes!',
    cancel: 'not this time',
  },
  bet_entry: {
    lost: 'Lost',
    won: 'Won',
    bet: 'Bet',
    sale: 'Sale',
    disabled: 'Disabled',
    you_earned: 'You earned',
    profit: 'with a profit of',
    you_lost: 'You lost',
    shares: 'shares at an average price of',
    total: 'per share for a total of',
    you_paid: 'You paid',
    comission: 'as comission',
    resolution: 'The correct outcome was:',
    now_worth: 'Now worth',
    earned: 'Earned',
    paid: 'and paid',
    tooltip_text: 'Futuur charges a 10% commission on profits. For more on about how we charge, please see our FAQs.',
    tooltip_label1: 'Pre-commission profit',
    tooltip_label2: 'Commission rate',
    tooltip_label3: 'Commission',
  },
  bet_info: {
    warning_line1: 'Futuur charges a 10% commission fee over your earnings.',
    warning_line2: 'For more information check the how we charge section.',
    otherBets: 'Your other bets on this market',
    aggregate: 'Aggregate results',
    past: 'Past positions',
    last: 'bet status',
    open: 'bet status',
  },
  bet_history: {
    all: 'All Bets',
    past: 'Past Bets',
    active: 'Active Bets',
    view_all: 'View All',
    following: 'View Forecasters You Follow',
    note: 'Note: ',
    tooltip_text: `for security reasons you can only see other user's Ooms data. To place bets using Ooms change your active
    currency.`,
    all_types: 'All',
    play_money: 'Play money',
    real_money: 'Real money',
    dismiss: 'Dismiss',
    only_followers: 'Only people I follow',
    my_bets: 'My bets',
    no_bet_found: 'No bet found',
    be_the_first: 'Be the first forecaster for this market',
    search_here: 'Search here',
    amount_column_info_message: 'Bets in real money are shown in USD equivalent for your convenience.',
    at: 'at',
  },
  cash_in: {
    kyc: 'Account Verification',
    deposit_succeeded: 'Deposit succeeded',
    kyc_title: 'Please **verify your ID** to unlock deposits',
    currencyList_subtitle: 'Please, select an option:',
    add_bitcoins: 'Add Crypto to your Futuur account',
    add_currency: 'Transfer to your Futuur ${this.currency} Wallet',
    add_funds: 'Add Funds',
    buy_btc: 'Buy Crypto',
    buy_crypto: 'Buy Crypto',
    copy_link: 'Copy Address',
    wallet_address: 'Your Futuur ${this.currency} Wallet Address',
    currency_list: 'Currency List',
    current_balance: 'Current Balance:',
    deposit_being_processed: 'Your deposit is being processed',
    deposit_instructions: 'Scan the QR or copy address to deposit. New to crypto? ',
    learn_how: 'Learn how',
    go_to_home: 'Go to Home',
    go_to_payment_gateway: 'Go to Skrill',
    is_being_processed: 'is being processed',
    minimum_deposit: 'Minimum deposit is 1.0',
    proceed_to_payment: 'Proceed to Payment Method',
    question_deposit_amount: 'How much do you want to deposit?',
    send_money: 'Send ${this.currency} to this address to add funds to your account',
    third_party_payment: 'Third Party Payment Method',
    my_transactions: 'View all transactions',
    view_all_transactions: 'My Transactions',
    we_use: 'We use',
    your_deposit_of: 'Your deposit of',
    see_withdraw_fees: 'See withdrawal fees',
    see_withdraw_fees_here: 'here',
    we_use_complement:
      'services to safely and securely process payments. You will be redirected back to Futuur once your payment is complete. See you soon!',
    tooltip_title: '${this.currencyLabel} Fees',
    tooltip_fee_1: 'A',
    tooltip_fee_2: 'fee is charged by our payments provider for each withdrawal.',
    tooltip_withdrawal: 'Minimum Withdrawal is',
    missing_data: {
      title: 'Please provide some additional information ',
      description:
        "To comply with regulations, we need to collect basic information that won't be shared or sold unless legally required.",
    },
    network: 'Blockchain Network',
    network_placeholder: 'Please select a network',
    make_sure_network:
      'Please ensure you are using the correct Network. Transfers made to the wrong Network may be lost.',
    remaining_wagerings: 'Remaining wagering requirement: ',
    bonus_disclaimer:
      'Deposits are withdrawable anytime. Bonuses need <span class="!font-bold">${this.remaining_bets}</span> more resolved bets.',
    notification: {
      title: 'Address copied!',
      body: 'The address of your Futuur wallet has been copied.',
    },
    deposit: 'Deposit',
    choose_network: 'Choose the network',
    choose_network_subtitle: 'Select the network you will use to send ${this.currency}.',
    change_network: 'Change network',
    wallet_sent: {
      title: 'Payment sent!',
      body: 'Your deposit will be credited once it is confirmed on-chain.',
    },
    subtitle: 'Send USDC to your personal Futuur address.',
    your_address: 'Your address',
    address_on_network: '${this.currency} address on',
    fact_arrival: 'Usually credited within minutes of network confirmation.',
    fact_email: "We'll email you when it arrives. You can safely close this window.",
    or: 'or',
    pay_from_wallet: 'Pay from your wallet',
    pay_from_wallet_hint: 'any token, converted to USDC automatically',
    mark_as_sent: "I've sent the funds",
    deposit_instructions_short: 'New to crypto?',
    kyc_headline: 'Verify your ID to unlock deposits',
    retry: 'Try again',
    waiting: {
      title: 'Almost there!',
      subtitle: 'Waiting for your ${this.currency} on ${this.network}.',
      step_address: 'Address created',
      step_transfer: 'Waiting for transfer',
      step_credited: 'Credited to your wallet',
    },
    success: {
      subtitle: 'Deposit confirmed and added to your wallet.',
      subtitle_network: 'Deposit confirmed on ${this.network} and added to your wallet.',
      view_wallet: 'View wallet',
    },
    deposit_crypto: 'Deposit Crypto',
    send_address_to_deposit: 'Deposit address',
    use_only: 'Use ${this.network} only – funds sent to the wrong network may lead to loss',
    select_a_currency: 'Select a currency',
    select_a_cryptocurrency: 'Select a cryptocurrency',
    cryptocurrency: 'Cryptocurrency',
    amount: 'Amount',
    select_realy_money: {
      fiat: {
        title: 'USD, EUR, BRL and others',
        description: 'Credit card, bank transfer, or other payment methods',
      },
      crypto: {
        title: 'Deposit Crypto',
        description: ' Choose the cryptocurrency of your choice',
      },
      more: 'more',
    },
    astropay_explained: 'Payment will be processed by <br/> Astropay, our payment partner',
    and_other: 'and others',
    deposit_status: {
      APPROVED: {
        title: 'Deposit made successfully!',
        description: 'Funds are now available in your wallet.',
        view_transactions: 'View my transactions',
        ok: 'Okay, got it',
      },
      SUCCESS: {
        title: 'Deposit made successfully!',
        description: 'Your deposit of <b>${this.amount} ${this.currency}</b> is already available in your wallet.',
        view_transactions: 'View my transactions',
        ok: 'Start forecasting',
      },
      PENDING: {
        title: 'Deposit in proggress',
        description: 'Your deposit is being processed, you will receive an email as soon as it is confirmed.',
        ok: 'Okay, got it',
      },
      CANCELLED: {
        title: 'Deposit cancelled!',
        description: 'Your deposit has been cancelled, please try again.',
        ok: 'Okay, got it',
      },
      ERROR: {
        title: 'Forbidden country',
        description:
          'Unfortunately your country is not supported for real-money deposits or betting. However you may continue to bet in play-money. If your country of residence has changed, you can update it <a class="link" href="/p/personal-info-update" >here</a>.',
        ok: 'Okay, got it',
      },
    },
    pix_success_paragraph: 'Access your bank, opt for Pix payment, and complete your transaction.',
    crypto_success_paragraph: 'Use the correct network to avoid losing transfers. ${this.network}',
    edit_info: 'Edit info',
    done: 'Done',
    you_will_be_redirected_title: 'You will be redirected to',
    you_will_be_redirected_paragraph: 'Your transaction will be processed by our trusted payment partner',
    you_have_been_redirected_title: 'You have being redirected to',
    you_have_been_redirected_paragraph: 'Your transaction will be processed by our trusted payment partner',
    withdraw_status: {
      pending: {
        title: 'You have a pending withdraw',
        description:
          'You already have a pending withdrawal of <b>${this.amount}</b>. Please confirm this withdrawal on the email we’ve sent you.',
        cta: 'Resend Email',
      },
      post_submition: {
        title: "We've sent you a <b>confirmation email</b>",
        description: 'Please click on the confirmation link in the email within 48 hours to complete your withdrawal.',
        cta: 'Okay, got it!',
      },

      cancel_withdraw: {
        cta: 'Cancel withdrawal',
        toast_message_title: 'Withdrawal canceled',
      },
      resend_sent: {
        toast_message_title: 'Email sent',
        toast_message_description: 'Please check your inbox and confirm your withdrawal',
      },
    },
    other_deposit_methods_title: 'Other options',
    other_deposit_methods_description: 'Credit card, bank transfer, PicPay or other payment methods',
    direct_deposit_description: 'Your deposit will be processed in minutes',
    pix_only_for_brazil: 'This option is available only for Brazilan resident',
    pix_only_for_mexico: 'This option is available only for mexican resident',
    pix_key_notification: {
      title: 'Pix key Copied',
      description: 'The pix key is copied, you can use it to make a deposit',
    },
    pix_qr_title: 'Deposit via Pix',
    pix_qr_description:
      'Access your bank, opt for Pix payment, and complete your transaction. Code valid for 30 minutes.',

    SPEI_key_notification: {
      title: 'SPEI key Copied',
      description: 'The SPEI key is copied, you can use it to make a deposit',
    },
    SPEI_qr_title: 'Deposit via SPEI',
    SPEI_qr_description: 'Please complete the transfer to the following CLABE',
    SPEI_copy: 'Copy the code below to complete your transfer',
    fiat_on_hold: 'Fiat deposits are temporarily paused for maintenance.',
    eoa: {
      wallet: 'Wallet',
      from: 'From',
      no_balance: 'No balance available',
      continue: 'Transfer Crypto',
      connect_next_step: 'Connect wallet in next step',
      from_eoa: 'From EOA',
      loading: 'Loading...',
    },
    direct: {
      title: 'Direct deposit',
      description: 'Scan the QR or copy address to deposit.',
    },
    onramper: {
      title: 'Deposit with Card, Pix and more',
      description: 'Simple and secure',
    },
    fiat: {
      title: 'Deposit FIAT',
      description: 'Placeholder',
    },
    go_back: 'Go back',
    currency: 'Currency',
    select_currency: 'Select a currency',
    fiat_group: 'Fiat',
    crypto_group: 'Crypto',
    copy: 'Copy',
    loading_deposit_address: 'Loading deposit address...',
    unable_to_load_address: 'Unable to load deposit address. Please try again later.',
    fiat_coming_soon: 'Fiat deposit coming soon',
  },
  how_to_buy_bitcoins: {
    buy_btc: 'Buy Cryptocurrencies',
    intro_text:
      'If you need to purchase crypto, you can do so on any of the following exchanges. You can then deposit to Futuur by making a transfer from the exchange to your Futuur wallet address.',
    info_pix: 'PIX for instant transfers',
    info_bank_transfer_deposit: 'Bank transfer and debit card',
    info_direct_purchase: 'Book or Direct Purchase',
    info_purchase_methods_1: 'Accepts PagSeguro, Paypal and Mercado Pago',
    info_find_exchange_p2p: 'Find best exchange on P2P market',
    info_pay_credit_card: 'Pay with Credit Card',
    info_directly_futuur_wallet: 'Directly to your Futuur Wallet',
    info_check_country: 'Check for country and State eligibility',
    info_buy_sell_bitcoins: 'Buy and sell Cryptocurrencies',
    info_bank_account_debit_credit: 'Bank account, credit card and debit card',
    go_to: 'Go to ${this.provider}',
  },
  kyc: {
    status: {
      no_need: 'No verification needed',
      initialized: 'In Progress',
      refused: 'Refused',
      approved: 'Approved',
    },
    action: 'Start',
    paragraph: {
      refused: 'Your Identity verification was refused. Please try again.',
      requested: 'Raise your deposit limits by completing our KYC process.',
    },
  },
  kyc_warning: {
    text: 'In order to keep Futuur safe we need you to send your identity declaration. It will take no more than 2 minutes.',
    small_title: 'Oops! You are locked for making new bets',
    start_id_verification: 'Start ID Verification',
    verify_your_identity: 'Verify your identity',
    unlock_deposit_warning:
      'Unlock higher deposit limits and improve overall security to your account. Start the KYC process now.',
  },
  kyc_form: {
    first_name: 'First name',
    last_name: 'Last name',
    country: 'Country of residence',
    country_placeholder: 'Country of residence',
    date: 'Date of birth',
    date_format_mdy: 'MM/DD/YYYY',
    date_format_dmy: 'DD/MM/YYYY',
    invalid_date: 'Enter a valid date',
    submit: 'Submit',
    error_first_name: 'Minimum 5 characters required',
    error_date: 'Select your date of birth',
    error_country: 'Select your country of residence',
    address: 'Address',
    address_placeholder: 'Add your full address',
    success_message: 'Personal info updated',
    error_last_name: 'Minimum 5 characters required',
    error_address: 'Minimum 5 characters required',
    first_name_placeholder: 'Add your first name',
    last_name_placeholder: 'Add your last name',
  },
  withdraw: {
    currency_list: 'Select Currency',
    add_skrill_account: 'Add a Skrill Account',
    available_withdraw_methods: 'Available Withdraw Methods',
    wallet_address: '${this.currency} Address',
    wallet_address_placeholder: 'Your ${this.currency} wallet address',
    choose_funds_destination: "Choose your funds' destination",
    continue: 'Continue',
    current_balance: 'Current Balance:',
    how_much_send_via: 'How much do you want to send via',
    how_much: 'How much ${this.currency} do you want to withdraw?',
    is_being_processed: 'is being processed',
    minimum_withdraw_crypto: 'Minimum Withdrawal is ${this.value}',
    money_on_the_way: 'Money is on the way!',
    invalid_address: 'Invalid address',
    invalid_address_warning: 'This does not appear to be a properly formatted address for ${this.currencyName}.',
    payment_being_processed: "Your withdraw is being processed, we will let you know once it's done.",
    tax_withdraw_crypto: 'Please note that a ${this.tax} fee is charged by our payments provider on each withdrawal',
    send: 'Send',
    view_all_transactions: 'View All Transactions',
    withdraw_done: 'Your money is on the way!',
    withdraw_funds: 'Withdraw',
    withdraw_value: 'Withdraw Value',
    withdraw: 'Withdraw',
    your_amount_of: 'Your withdraw of ',
    user_no_account_for_currency: 'You need to add funds to this currency first',
    values_in_mbtc: 'Enter your withdrawal amount in miliBitcoin (1 mBTC = 0.001 BTC)',
    warning_usdc: 'Only use ${this.blockchain} network for this transaction, otherwise your funds may be lost.',
    currently_have: 'You currently have ',
    min_value: 'Minimum withdrawal amount is ${this.min_value}',
    max_value: 'Maximum withdrawal amount is ${this.max_value}',
    destination_chain: 'Destination Chain',
    ensure_network:
      'Please, ensure you are using the correct Network. Transfers made to the wrong network may be lost.',
    withdraw_funds_to_astropay: 'Withdrawal funds to your Astropay Account',
    withdraw_funds_to_pix: 'Withdrawal funds to your Bank Account via PIX',
    pix_key: 'Enter your Pix Key',
    payment_will_processed_with_astropay: 'Payment will be processed by Astropay, our payment partner',
    amount: 'Amount',
    edit_information: 'Edit informations',
    cpf: 'What is your CPF?',
    random_key: 'Random Key',
    cell_phone: 'Cell Phone',
    resume: 'Resume',
    pix_key_type: 'Pix Key type',
    review_transfer: 'Review your transfer:',
    withdrawal_under_min_amount: 'Withdrawal under minimum amount',
    min_ten: 'Minimum withdrawal: $10 or R$60. ',
    enter_pix_key: 'Please enter your pix key',
    crypto_info_message: 'Transfers to the wrong network may be lost.',
    defined_fee_charged_by_our_provider_message: 'Fee: ${this.fee} ${this.currency} charged by our provider.',
    fees_charged_by_our_provider_message: 'Fees for ${this.currency} are charged by our provider.',
    fees: 'Fees',
    balance: 'Balance',
    address: 'Address',
    enter_your_address: 'Enter your address',
    cpf_format_error: 'Please respect this format 000.000.000-00',
  },
  withdraw_email_received: {
    title: 'Confirmation email sent, check your inbox',
    text: 'Please click the link on the confirmation email to verify your request and initiate the withdrawal process',
    close: 'Close',
  },
  withdraw_validation: {
    no_longer_valid: 'Your withdraw of <b>${this.amount}</b> <span>${this.currency}</span> is no longer valid',
    initiated: 'Your withdraw has been initiated.',
    receive_notification: 'You will receive a notification and email when the transaction is complete.',
    request_another: 'Please, place another request if you wish to withdraw funds from your account',
    error_p1:
      'An error occurred while trying to validate your request. Your token might be expired or the request is already validated.',
    error_p2: 'If you need additional support, please contact us.',
    go_to_markets: 'Go to Markets',
    view_transactions: 'View all my transactions',
    request_verified: 'Request Verified!',
    request_canceled: 'This Request was cancelled!',
    title_error: 'Ops... something wrong',
    verifying_request: 'Verifying request',
  },
  chart: {
    timeframes: {
      day: '1D',
      week: '1W',
      month: '1M',
      year: '1Y',
      all_time: 'All',
    },
  },
  wallet: {
    balance: 'Balance',
    meta_tags: {
      title: 'My Wallet | Futuur',
      description:
        'Manage your Futuur wallet — view balances, deposit, withdraw, and review your transaction history across currencies.',
    },
    add_funds: 'Add funds',
    withdraw: 'Withdraw',
    transactions: 'Transactions',
    date_format: 'd MMMM, yyyy',
    all_time: 'All time',
    ooms_balance: 'Ooms Balance',
    wallet_name: '${this.currency} Wallet',
    pending_withdraw:
      `You have a pending withdrawal of ` + '${this.amount}.' + ` Approval typically occurs within 24 hours.`,
    all: 'All actions',
    incomes: 'Credits',
    outcomes: 'Debits',
    export: 'Export',
    account_activity: 'Account Activity',
    current_balance: 'Current balance',
    wallet: 'Wallet',
    action_wager_purchase: 'Bet',
    action_wager_sale: 'Sale',
    action_fee: 'Fees',
    action_wager_win: 'Win',
    action_wager_lose: 'Lose',
    action_deposit: 'Deposit',
    action_withdraw: 'Withdraw',
    action_initial_balance: 'Initial',
    action_question_cancelled: 'Cancelled',
    action_question_reversion: 'Reverted',
    action_transaction_reversion: 'Reverted',
    action_manual_transaction: 'Manual',
    action_withdrawal_request: 'Withdraw resquest',
    action_question_settlement: 'Settlement',
    action_pending_withdraw: 'Pending withdraw',
    action_cancel_withdraw: 'Cancel Request',
    action_other: 'Other',
    no_result: "We didn't find any results",
    from: 'From',
    to: 'To',
    custom_period: 'Custom period',
  },
  currency_selector: {
    title: 'Currency Selector',
    intro: 'Select the markets you want to explore and pick the currency to make forecasts with',
    about: 'About',
    info: 'Changing your active currency will change the currency you use to make bets on Futuur. Choose Ooms to bet using play money, or Cryptocurrencies to bet using real money.',
    dismiss: 'Dismiss',
    add_funds: 'Add funds',
    add_more: 'Add More',
    deposit: 'Deposit',
    withdraw: 'Withdraw',
    confirm: 'Confirm active currency',
    continue: 'Continue',
    cancel: 'Cancel',
    play_money_markets: 'Play Money Markets',
    real_money_markets: 'Real Money Markets',
    play_money_title: 'Ooms',
    real_money_title: 'Real Money',
    play_money: 'Play Money',
    view_only: 'View only',
    real_money: 'Real Money',
    tooltip_title: 'How it works',
    tooltip_description:
      'The Currency Selector determines which markets you will see (real-money or play money), as well as which currency you are betting with.',
    check_wagering_forbidden_country:
      'While we do not offer real-money wagering on your jurisdiction, you can access them on a view-only basis',
    check_web_version:
      'To check for real-money wagering eligibility go to our web-based version in <a href="https://futuur.com" target="_blank" >https://futuur.com</a>',
    please_register: 'To place bets and receive 10000 Ooms, please register.',
    register: 'Register',
    sign_in: 'Sign in',
    add_or_remove_currency: 'Add or remove currency',
    intro_app:
      'You are only allowed to view the Ooms Markets based on your jurisdiction. To check for Real Money Markets availability, please <a href="https://futuur.com" target="_blank" >View the Web Version</a>.',
    check_availability: 'check for availability',
    view_web_version: 'View web version',
    no_funds: 'Please deposit funds to bet on real-money markets',
    fromForbiddenCountry:
      'You are accessing Futuur from a Restricted Jurisdiction and are not able to bet on real-money markets.  However, you can view real-money markets and forecasts, and you are welcome to bet in our Play-Money markets!',
    confirm_button: 'Confirm change',
    change_for: 'Change for ',
    currency_changed: 'Currency selected changed',
    currency_changed_description: 'You are now seeing ${this.currency_mode} markets.',
    offline_description:
      'You are viewing crowd-generated forecasts from ${this.currency_mode} markets. To view forecasts from ${this.other_mode} markets, use the toggle below.',
    add_another_currency: 'Add another currency',
    click_to_select: 'Click to select default currency to bet',
    sigin_in: 'To make bets, please sign in :',
    no_funds_yet: 'No funds yet',
  },

  pwa_installation: {
    title: 'Add Futuur to home screen?',
    subtitle: 'For quick and easy access',
    actionButton: 'Add to home screen',
  },
  convert_to_stable_coin_modal: {
    title: 'Limit Orders have arrived—set your price and trade only when it’s met.',
    description:
      'To cut fees and end price swings, real-money markets will now operate exclusively in <b>USDC</b>. Have a balance in another currency? Convert it instantly or withdraw it anytime.',
    withdraw_button: 'Withdraw',
    convert_button: 'Convert',
    new_feature_title: 'New feature: ',
    limit_order_title: 'limit order!',
    limit_order_description: 'Now you can make an order to buy or sell at a specified price or better.',
    know_more: 'Know more',
    got_it: 'Got it',
  },
  onboarding_tour: {
    first_slide: {
      title: 'Build your skills + reputation',
      subtitle: 'with our Play Money!',
      description: 'With Ooms, Futuurs Play-Money currency, you can forecast risk-free.',
    },
    second_slide: {
      title_allowed_country: {
        highlighted: 'Make money with',
        regular: ' what you know',
      },
      description_allowed_country: 'Put your skills to the test with real money.',
      title_not_allowed_country: 'See the future',
      description_not_allowed_country: 'For the most accurate forecasts, powered by the crowd.',
    },
    third_slide: {
      title_email_not_verified: {
        highlighted: 'One step left:',
        regular: ' confirm your email',
      },
      description_email_not_verified: 'Please check your inbox. Didn’t get the email?',
      resend_button: 'Resend',
      title_email_verified: {
        pre: 'Turn your ',
        highlighted: 'insights into action',
        post: ' and help generate more accurate predictions for everyone.',
      },
      description_email_verified: 'New markets everyday across a wide range of topics.',
      start_button: 'Start forecasting',
    },
    skip_button: 'Skip',
    email_resent: 'Email resent',
    loading_message: 'Loading onboarding tour...',
  },

  ask_notification_permission: {
    header: 'Browser notifications',
    title: 'Allow Futuur to send browser notifications',
    subtitle: 'Stay updated on the latest Futuur markets!',
    actionButton: 'Allow Browser Notifications',
    actionButtonEnabled: 'Notifications enabled',
    enabled: 'Browser notifications enabled',
    alreadyEnabled: 'Browser notifications were already allowed',
    alreadyEnabledHint:
      'This site already has permission. The browser will not show Allow / Block again until you reset notifications in site settings.',
    deniedTitle: 'Notifications blocked',
    denied:
      'Enable notifications for this site in your browser settings to receive alerts.',
    error: 'Could not enable browser notifications. Please try again.',
  },
  error: {
    text: '<b>Unexpected issue encountered ! <br/> We&apos;re actively working to resolve this.</b> <br/> <br/>  In the meantime, you can save the fish or click the button to return to the feed.',
    button: 'Go to feed',
  },
  user_preview: {
    joined: 'Joined',
    view_profile: 'View Profile',
    market_traded: 'Markets traded',
    win_rate: 'Win rate',
    life_time_profit_and_loss: 'Life time profit/loss',
    open_positions: 'Open positions',
    follow: 'Follow',
    unfollow: 'Unfollow',
  },

  account_settings: {
    delete_account: {
      delete_account_button_text: 'Delete account',
      skip_button_text: 'Skip',
      submit_button_text: 'Submit',
      errors: {
        withdraw_before_delete: {
          title: 'Withdraw before deleting',
          body: 'Withdraw your full balance first.',
        },
      },
      reasons: {
        lost_too_many_times: "I've lost too many times",
        markets_are_not_interesting: "Markets aren't interesting",
        ran_out_of_play_money: 'I ran out of play money',
        lack_of_volume_in_markets: 'Lack of volume in markets',
        lack_of_engagement_between_players: 'Lack of engagement between players',
        other: 'Other',
      },
      reason_selector_title: 'Can you share the reason why?',
      reason_selector_info_message: "This will help us improve our product. Don't worry, you won't be contacted.",
      add_your_reason: 'Add your reason',
      confirmation_title: 'Do you want to delete your account?',
      confirmation_info_message:
        'Important reminder: Deleting your account will permanently erase your forecasting history, and it cannot be recovered.',
      cancel_button_text: 'Cancel',
      confirm_deletion_button_text: 'Confirm and delete',
      account_deleted_successfully: 'Account deleted successfully',
    },
    password_update: {
      success_message: 'Password updated successfully',
      current_password: 'Current Password',
      new_password: 'New password',
      confirm_new_password: 'Confirm new password',
      passwords_dont_match: "Passwords don't match",
    },
    public_api: {
      enable_real_money_public_api_toast: {
        title: 'Public API was successfully enabled for real money',
      },
      disable_real_money_public_api_toast: {
        title: 'Public API was successfully disabled for real money',
      },
    },
    security: {
      info_message: 'We will send a password recovery link to your email address.',
      send_recovery_link: 'Send recovery link',
      recovery_email_sent: 'Recovery Email Sent',
      check_your_email: 'Please check your email for password recovery instructions.',
      email_not_found: 'User email not found',
      recovery_failed: 'Failed to send recovery email. Please try again.',
    },
  },
  live_strip: {
    title: 'Live',
    commented: 'commented',
  },
  home_highlight: {
    featured: 'Featured markets',
    volume: 'vol',
    slide_position: '${this.current} of ${this.total}',
    previous: 'Previous market',
    next: 'Next market',
    top_forecasters: 'Top forecasters',
    week: 'week',
    month: 'month',
    see_all_forecasters: 'See the full leaderboard',
    forecasters_unavailable: 'Rankings are unavailable right now.',
    forecaster_placeholder: 'To be defined',
    commented_on: 'commented on',
    recent_comments: 'Recent comments',
    comments_unavailable: 'Comments are unavailable right now.',
    no_comments: 'No comments yet.',
  },
  midterm_banner: {
    eyebrow: 'US Midterms · Nov 3, 2026',
    title: 'Who controls the Senate?',
    subtitle: 'Live odds on every midterm race — Senate, House and governors.',
    majority: 'Majority',
    cta_markets: 'See all midterm markets',
  },
  midterm_map: {
    title: 'US Midterms',
    tab_all: 'All races',
    tab_senate: 'Senate',
    tab_house: 'House',
    tab_governors: 'Governors',
    countdown_days: 'Days',
    countdown_hours: 'Hrs',
    countdown_minutes: 'Min',
    countdown_seconds: 'Sec',
    election_day: 'Election Day',
    no_market: 'No market yet',
    no_market_hint: 'There is no open midterm market for this state yet. The races below cover the states in play.',
    state_races: '${this.count} in this state',
    race_senate: 'Senate',
    race_governor: 'Governor',
    race_house: 'House',
    race_other: 'Race',
    loading: 'Loading the map…',
    senate_seats: '100 seats',
    house_seats: '435 seats',
    senate_control: 'Who controls the Senate',
    house_control: 'Who controls the House',
  },
  hot_topic_banner: {
    markets: 'markets',
  },
  setup_email_modal: {
    success_title: 'Confirmation sent',
    success_message: 'Check the new inbox and click the link. Futuur will keep using your current address until then.',
  },
  deposit: {
    setup_email_modal: {
      title: 'Deposit',
      description:
        'For security, we ask for your email to confirm future withdrawals. You’ll also get weekly portfolio updates, which you can disable anytime in settings.',
    },
  },
  common: {
    close: 'Close',
    scroll_left: 'Scroll left',
    scroll_right: 'Scroll right',
    markets: 'Markets',
    score: 'Score',
    filter_by: 'Filter by',
    currencies: 'Currencies',
    real_money: 'Real money',
    play_money: 'Play money',
    others: 'Others',
    apply: 'Apply',
    reset_filters: 'Reset filters',
    only_people_i_follow: 'Only people I follow',
    my_bets: 'My bets',
    filters: 'Filters',
    date: 'Date',
    action: 'Action',
    market: 'Market',
    outcome: 'Outcome',
    price: 'Price',
    amount: 'Amount',
    user: 'User',
    share: 'Share',
    error: 'Something went wrong',
    errors: {
      server_error: {
        title: 'Server Error',
        message: 'Please contact support for further investigation',
      },
    },
    available: 'Available',
    min: 'Min',
    all: 'All',
    max: 'MAX',
    paste: 'Paste',
    cheapest: 'Cheapest',
    no_fee: 'No fee',
    continue: 'Continue',
    see_more: 'See more',
    see_less: 'See less',
    play_money_only: 'Play money only',
    go_back: 'Go back',
    yes_cancel: 'Yes, cancel',
    new: 'New',
    email: 'Email',
    name: 'Name',
    email_placeholder: 'email@email.com',
    invalid_email: 'Invalid email',
    confirm: 'Confirm',
    skip: 'Skip',
    bet: 'Bet',
    categories: 'Categories',
    menu: 'Menu',
    notification: 'Notification',
    oops: 'Oops',
    retry: 'Retry',
    loading_chart: 'Loading chart',
    failed_to_load: 'Failed to load ${this.name}',
    loading_recent_bets: 'Loading recent bets...',
    loading_recent_comments: 'Loading recent comments...',
    failed_to_load_recent_bets: 'Failed to load Recent Bets',
    failed_to_load_recent_comments: 'Failed to load Recent Comments',
    select_a_specific_date: 'Select a specific date',
    currency_overview: 'Currency overview',
    unexpected_issue: 'Unexpected issue encountered',
    today: 'Today',
    betting_panel_error: 'Betting Panel Error',
    failed_to_load_betting_panel: 'Failed to load betting panel',
    something_went_wrong: 'Something went wrong',
    component_failed_to_load: 'Component failed to load',
    no_open_orders_description: "You don't have any open orders. Place some limit orders to see them here.",
    select_outcomes_to_compare: 'Select outcomes to compare',
    start_the_conversation: 'Start the conversation!',
    type_your_message: 'Type your message...',
    enter_your_name: 'Enter your name',
    enter_your_email: 'Enter your email',
    this_market_is_hot: 'This market is set as hot',
    withdraw_status: 'Withdraw status',
  },
  hardcoded: {
    profile_updated: 'Your profile has been updated',
    wallet_signup_not_configured: 'Wallet signup is not configured.',
    wallet_login_not_configured: 'Wallet login is not configured.',
    could_not_get_login_token: 'Could not get login token. Please try again.',
    google_login_failed: 'Google login failed. Please try again.',
    facebook_login_failed: 'Facebook login failed. Please try again.',
    transaction_completed: 'Transaction Completed',
    transaction_failed: 'Transaction Failed',
    unable_to_copy_link: 'Unable to copy link. Please contact support.',
    order_filled: 'Order Filled',
    partial_fill: 'Partial Fill',
    login_failed: 'Login failed',
    oops_something_wrong: 'Oops! Something went wrong, please try again later',
    failed_to_fetch_order_book: 'Failed to fetch order book data',
    two_fa_enabled: '2FA enabled',
    two_fa_disabled: '2FA disabled',
    bridge_quote_error: 'Bridge Quote Error',
    bridge_error: 'Error',
    executing_bridge: 'Executing Bridge',
    bridge_executed: 'Bridge Executed',
    bridge_execution_error: 'Bridge Execution Error',
    bridge_routes_error: 'Bridge Routes Error',
    failed_to_load_recent_bets_error: 'Failed to load recent bets',
    edit_profile: 'Edit profile',
    select_outcomes_to_compare: 'Select outcomes to compare',
    download_chart: 'Download Chart',
    candlestick_chart: 'Candlestick Chart',
    line_chart: 'Line Chart',
    could_not_complete_sign_in: 'Could not complete sign in.',
    completing_sign_in: 'Completing sign in…',
    sign_in_could_not_be_completed: 'Sign in could not be completed.',
    back_to_login: 'Back to login',
    code_copied_successfully: 'Code is copied successfully',
    copy: 'Copy',
    key_copied_successfully: '${this.type} key is copied successfully',
    pending: 'Pending',
    okay: 'Okay!',
    current: 'Current',
    to_beat: 'To beat',
  },
  not_found: {
    title: 'We lost that page…',
    description: "Sorry, the page you are looking for doesn't exist or has been moved. Here are some helpful links:",
    home: 'Home',
    home_description: 'Go back to the main page',
    help_center: 'Help Center',
    help_center_description: 'Get support and answers',
    blog: 'Blog',
    blog_description: 'Read the latest posts',
    api_docs: 'API Docs',
    api_docs_description: 'Explore our API documentation',
  },
  convert: {
    title: 'Convert to stablecoin',
    description:
      'Select the currency you would like to convert. The full balance is converted, with no fees, at the exchange rate.',
    from: 'From',
    to: 'To',
    stablecoin: 'USD stablecoin',
    rate: 'Exchange rate',
    fee: 'Conversion fee',
    no_convertible_balance: 'You have no balance available to convert.',
    go_to_wallet: 'Go to wallet',
  },
  open_positions: {
    avg_share_price: 'Av. Share Price',
    now_worth: 'Current Value',
    current_profit: 'Profit',
  },
  profile_transactions: {
    search_placeholder: 'Search markets and outcomes...',
  },
  recent_bets: {
    title: 'Recent Bets',
    no_bets_yet: 'No recent bets yet',
  },
  recent_comments: {
    title: 'Recent Comments',
  },
  feed_rail: {
    bought: 'Bought',
    sold: 'Sold',
    top_forecasters_week: 'Top forecasters · week',
    all: 'All',
    live_activity: 'Live activity',
  },
  bet_tooltip: {
    avg_price_paid: 'Avg. price (paid)',
    avg_price_sell: 'Avg. price (sell)',
  },
  order_row: {
    created_at: 'Created at',
  },
  active_bet: {
    low_liquidity: 'Low liquidity',
    low_liquidity_description:
      'Only ${this.available} of ${this.total} shares can be sold right now — the other ${this.remaining} have no buyers yet.',
  },
  candlestick: {
    error_prefix: 'Error',
    failed_to_connect: 'Failed to connect to Binance WebSocket',
  },
  trading_halt: {
    title: 'Trading is paused',
    body: 'New orders are paused. Your positions stay. You can keep browsing.',
  },
  site_control: {
    staff_sign_in: 'Staff sign in',
  },
}
